jQuery(function ($) {
    var $cart = $('.cart .cart-section'),
        $alertContainer = $('#alert-container')
    $alertTrigger = $('a.lightbox[href="#alert-container"]');

    function renderError(message) {
        $alertContainer.html(message);
        $alertTrigger[0].click();
    }

    $cart.on('click.cart.remove', '.icon-trash input[type="submit"]', function (_event) {
        return window.confirm("Are you sure you want to remove this item?");
    });

    // Add indicator for selected frame. CH: Change this based on new layout.
    $cart.on('change.cart.frames.select', '.frames input[type="radio"]', function (event) {
        var $input = $(this), $container = $input.closest('.frames');
        $container.find('ul > li').removeClass('selected');
        $input.closest('figure').parent('li').addClass('selected');

        //Testing
        //$inputs = $('.frame-container').find(':input');
        //$inputsSerialized = $inputs.serializeArray();

        //console.log($inputsSerialized[0]);
    });

    $cart.on('click.checkout', '> header .submit.button, .total-footer .cart-buttons .submit.button', function (event) {
        var $button = $(this),
            action = $button.attr('formaction'),
            href = $button.attr('href');

        $button.on('click.submitting', function () {
            // Prevent consecutive click on this button,
            // which will be removed once success.
            return false;
        });

        $button.prop('disabled', true).addClass('submitting');

        var $forms = $cart.find('form.line-item:not(.placeholder)');
        var allData = [];

        $forms.each(function (index) {
            var $form = $(this);
            var data = $form.serializeArray();
            $.each(data, function (_index, datum) {
                datum.name = datum.name.replace(/^Data\[[\d]+\]\./, 'Data[' + index + '].');
            });
            Array.prototype.push.apply(allData, data);
        });

        $.ajax({
            type: 'POST',
            url: action,
            data: allData,
            success: function (res) {
                $button.removeClass('submitting');
                $button.off('click.submitting');

                if (res.Success) {
                    $button.addClass('submitted');

                    // Redirect to the URL in href attribute.
                    window.location = href;
                } else {
                    $alertContainer.html(res.Message);
                    $alertTrigger[0].click();
                }

                setTimeout(function () {
                    $button.prop('disabled', false);
                    $button.removeClass('submitted');
                }, 500);

            }
        });

        return false;
    });

    function isDesktop() {
        return !$('.meta-nav .for-mobile-menu').is(':visible');
    }

    // Toogle painters collapsible.
    var $painterLoaders = $cart.find('pinots-painter-loader');
    $painterLoaders.each(function () {
        handlePainterLoader(this, false);
    });
    var hasOneOpen = false;

    function handlePainterLoader(loader, initialized) {
        var $collapsible = $(loader).closest('collapsible-set'), $toggle;

        loader.onload = function (results) {
            if (!results.Success) {
                renderError(results.Message);
                return;
            }

            $toggle = $collapsible.find('a[name="header"]');
            var isOpen = $toggle.hasClass('open'),
                seats = $(loader).attr('seats');

            if (results.Painters.length < Number(seats)) {
                // If one is already open on mobile, don't open this.
                if (!isDesktop() && hasOneOpen) return;

                // There are requested seats with no info.
                $('body').removeClass('collapse-open');
                return;
            } else {
                // After updating.
                if (!isDesktop() && hasOneOpen) return;
                $('body').removeClass('collapse-open');
                return;
            }

            // Otherwise,
            $('body').removeClass('collapse-open');
            $collapsible.removeClass('forced-open');
        }
    }

    // Close any forced open lightbox from collapsible on mobile.
    $cart.each(function () {
        $(window).on('resize.pinots.cart orientationchange.pinots.cart', function () {
            if (!isDesktop()) {
                $('collapsible-set.forced-open a[name="header"].open').each(function (idx) {
                    // Leave the first one open on mobile.
                    if (idx === 0) return;

                    this.click();
                    $(this).closest('collapsible-set').removeClass('forced-open');
                });
            }
        });
    });

    function renderCart($updatedLineItem) {
        var subtotal = 0, purchases = 0;

        // Update each line item's price with the new quantity.
        // We do it for all of items because user can change multiple quantity
        // fields before clicking Update.
        $cart.find('.line-item').each(function () {
            var $lineItem = $(this)
                , newQuantity = $lineItem.find('.quantity input.line-item-quantity').val();

            if ($lineItem.is($updatedLineItem)) {
                var $painters = $lineItem.find('pinots-painter-loader')
                    , seats = $painters.attr('seats');

                if (seats && Number(seats) !== Number(newQuantity)) {
                    // Set new params. The tag won't update at this point.
                    $painters.attr('seats', newQuantity);

                    var $toggle = $painters.closest('collapsible-set').find('a[name="header"]'),
                        toggle = $toggle[0];
                    handlePainterLoader($painters[0], false);

                    // Click the toggle to trigger "update" on `collapsible-set`, which also
                    // updates `pinots-painter-loader` as its child.
                    toggle.click();
                    setTimeout(function () {
                        toggle.click();
                    }, 1);
                }
            }

            // Update the (sale) price for this line item.
            var $prices = $lineItem.find('.cart-item__total-price.price .sale .value').each(function () {
                var $price = $(this);

                // Add the final price to subtotal.
                if (!$lineItem.hasClass('placeholder') && $price.parent('.sale').length) {
                    // subtotal += price;
                    var gross = $price.text().replace(/\(?\$?([-+]?(\d*[.])?\d+)\)?/, '$1');
                    subtotal += parseFloat(gross);
                    purchases++;
                    console.log(subtotal);
                }
            });
        });


        $cart.find('.cart-total .subtotal .value-subtotal').text(subtotal.toFixed(2));
        $cart.find('.cart-total .subtotal .value, .cart-review__estimate span').text(subtotal.toFixed(2));
        $('.meta-nav .icon-cart').text('(' + purchases + ')');
    }

    // Rerender cart the first time.
    // renderCart();

    // Event trigger by `forms.js`
    $cart.on('submitted', '.line-item', function (_event, $button, response) {
        if (response.Reload) {
            window.location.reload();
            return;
        }

        var $lineItem = $button.closest('.line-item'),
            orderDetailId = Number($lineItem.find('input[name$=".OrderDetailId"]').val());

        var orderDetail, data = response.Data || [];
        for (var i = 0; i < data.length; i++) {
            var item = data[i];
            if (item.Id === orderDetailId) {
                orderDetail = item;
                break;
            }
        }

        if (!orderDetail && $button.parent('.icon-trash').length) {
            // Removal won't have item in response.
            $lineItem.remove();
        } else {
            var gross = orderDetail.Gross,
                discount = orderDetail.Discount || 0,
                quantity = orderDetail.Quantity;

            $lineItem.find('.price del .value').text(gross.toFixed(2));
            $lineItem.find('.price .sale .value').text((gross - discount).toFixed(2));

            // Any element that needs to display unit value.
            $lineItem.find('.unit.value').text((gross / quantity).toFixed(2));
        }

        renderCart($lineItem);

        if (response.Reload) {
            window.location.reload();
        }
    });

    //CH: Possibly change this based on new layout if needed.
    $('body').on('click', '.frame-container .add-to-cart', function () {
        var $button = $(this);
        var $form = $button.closest('.frame-container');
        var action = $button.attr('formaction');
        var $class = $button.data('class');

        var $inputs = $form.find(':input');
        var $hiddenInputs = $inputs.filter(':disabled').prop('disabled', '');

        var data = $inputs.serializeArray();

        $.ajax({
            type: 'POST',
            url: action,
            data: data,
            success: function (res) {
                $hiddenInputs.prop('disabled', true);
                $button.removeClass('submitting');

                if (res.Success) {
                    if (res.Reload) {
                        document.location.reload();
                        return;
                    }

                    $button.addClass('submitted');
                    setTimeout(function () {
                        $button.removeClass('submitted');
                    }, 200);

                    $($class).slideUp();
                    $('.js-frameOptionsLaunch').removeClass('active');

                    // Retrieve the placeholder frame line-item.
                    var $lineItem = $form.closest('.line-item').nextAll('.placeholder.line-item:first');
                    $lineItem.after($lineItem.clone()).addClass('fade-in').removeClass('placeholder');

                    var orderDetail = res.Data, product = orderDetail.Product;

                    $('.description h2', $lineItem).text(product.DisplayName);
                    // Lightbox for frame only
                    var image = product.Image.replace(/^~/, '');
                    $('.description .image-lightbox', $lineItem).attr('href', image)
                        .find('img').attr('src', image);
                    // Lightbox for frame with  painting.
                    $('.frame-it a', $lineItem).each(function () {
                        var $framedLightBoxTrigger = $(this),
                            framedLightBoxHref = $framedLightBoxTrigger.attr('href');
                        $framedLightBoxTrigger.attr('href', framedLightBoxHref.replace(/-with-frame-([\d]+)/, '-with-frame-' + product.Id));
                    });
                    // OrderDetailId
                    $('input[name^="Data["][name$="OrderDetailId"]', $lineItem).val(orderDetail.Id);
                    // Order Details Quantity
                    $('input[name^="Data["][name$="Quantity"]', $lineItem).val(orderDetail.Quantity);
                    // Prices
                    var $finalPrice = $('.price .sale .value', $lineItem);
                    $finalPrice.text((orderDetail.Gross - orderDetail.Discount).toFixed(2));
                    if (!orderDetail.Discount) {
                        // No discount, remove the element.
                        $('.price del', $lineItem).remove();
                        $finalPrice.parent('.sale').html($finalPrice[0]);//used to have outerHtml
                    } else {
                        $('.price del .value', $lineItem).text(orderDetail.Gross.toFixed(2));
                    }

                    // Remove ID
                    $('input[name="RemoveOrderDetailId"]', $lineItem).val(orderDetail.Id);

                    renderCart($lineItem);

                } else {
                    $alertContainer.html(res.Message);
                    $alertTrigger[0].click();
                }
            }
        });
    });

    $('.button-collapse-launcher').on('click', function (e) {
        var dataId = $(this).data('id');

        $('.painter-details').addClass('active');
    });
});

function deleteItem(orderDetailId) {
    $(".delete-item-button").html("Processing... please wait");
    $.post('/API/UpdateOrderTotals', { RemoveOrderDetailId: orderDetailId }, function (result) {
        document.location.reload();
    });
}
jQuery(function($) {
  var $alertContainer = $('#alert-container')
      $alertTrigger = $('a.lightbox[href="#alert-container"]');

  function renderError(message) {
    $alertContainer.html(message);
    $alertTrigger[0].click();
  }


  var submitSelector = 'button[type="submit"]' +
                      ', input[type="submit"]' +
                      ', .add-to-cart.button' +
                      ', a.submit' +
                      ', button.submit';

  $('body').on('click.form.submit', submitSelector, function(_event) {
    $(this).addClass('submitting');
  });

  $('body').on('submit', 'form', function(event) {
    var $form = $(this);
    var $button = $form.find('button.submitting[type="submit"], input.submitting[type="submit"], a.submit.submitting, button.submit.submitting');

    // Disable submit buttons.
    $button.prop('disabled', true);

    if (!$form.hasClass('ajaxified')) {
      // Normal form submission, let it go.
      return true;
    }

    var submitName = $button.attr('name'), submitValue = $button.val();
    var action = $form.attr('action'), data = $form.serializeArray();

    if (submitName && submitValue) {
      // Mostly use for delete action since it uses input[type="submit"] 
      // with the order detail ID in its value.
      // jQuery's `.serialize`/`serializeArray` does not input those inputs.
      data.push({
        name: submitName,
        value: submitValue
      });
    }

    $.ajax({
      type : 'POST',
      url  : action,
      data : data,
      success :  function(res) {
        $button.removeClass('submitting');

        if (res.Success) {
          $button.addClass('submitted');
          $form.trigger('submitted', [$button, res]);

        } else {
          renderError(res.Message);
        }

        setTimeout(function () {
            $button.removeClass('submitted');
            $button.prop('disabled', false);
        }, 500);
      }
    });
    return false;
  });
});
var lat = null;
var long = null;

function getGeo() {
    try {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(setGeo, handleError);
        }
    }
    catch (e) {
        //$("#demo").html(e.message);
    }
}
function setGeo(position) {
    lat = position.coords.latitude;
    long = position.coords.longitude;
    setMetaNavPartialNearestLocation();
}
function handleError(error) {
    //alert("handleError");
    //loadLocations();

    var message = "Error not found";
    switch (error.code) {
        case error.PERMISSION_DENIED:
            message = "User denied the request for Geolocation."
            break;
        case error.POSITION_UNAVAILABLE:
            message = "Location information is unavailable."
            break;
        case error.TIMEOUT:
            message = "The request to get user location timed out."
            break;
        case error.UNKNOWN_ERROR:
            message = "An unknown error occurred."
            break;
    }
}

function setMetaNavPartialNearestLocation() {
    if (lat && long) {
        $.post('/api/locations', { Latitude: lat, Longitude: long, Limit: 1 }, function (result) {
            if (result.Success && result.Locations.length > 0) {
                $(".MetaNavPartialNearestLocation").html(result.Locations[0].Name);                
                $(".MetaNavPartialNearestLocationAnchor").attr("href", result.Locations[0].URL);
            }
        });
    }
}
function initPaintingPage() {
    $(".classes-list").hide();
    //$(".list-register").hide();
    $('#map-click').addClass("toggle-active");
    $('#list-click').addClass("toggle-inactive");
    $('#distance-sort').addClass('toggle-active');

    $("#map-click").click(function () {
        $('#map-click').addClass("toggle-active").removeClass("toggle-inactive");
        $('#list-click').addClass("toggle-inactive").removeClass("toggle-active");
        $(".classes-list").hide();
        $(".map-view").show();
    });

    $("#list-click").click(function () {
        $('#list-click').addClass("toggle-active").removeClass("toggle-inactive");
        $('#map-click').addClass("toggle-inactive").removeClass("toggle-active");
        $(".classes-list").show();
        $(".map-view").hide();
    });

    $('.class-listing a').click(function (e) {
        e.stopPropagation();
    });

    var map = new google.maps.Map(document.getElementById('map'), {
        styles: pinotStyle,
        zoom: 11
    });

    $(".class-listing").click(function () {
        //if ($(this).hasClass('class-listing-open')) return;

        //$('.class-listing-open .list-register').slideToggle("slow", function () {});
        $('.class-listing').removeClass('class-listing-open');
        $(this).toggleClass('class-listing-open');
        //$(this).find(".list-register").slideToggle("slow", function () {});
        var latLng = new google.maps.LatLng(+$(this).data('lat'), +$(this).data('lng'));
        map.panTo(latLng);
    });
    $(".class-listing").first().click();

    $('.sort').click(function () {
        $('.sort').removeClass('toggle-active');
        $(this).addClass('toggle-active');
        var sortBy = $(this).data('sort');
        $(".classes-map-list .class-listing")
            .sort(function (a, b) { return +$(b).data(sortBy) < +$(a).data(sortBy) ? 1 : -1; })
            .appendTo('.classes-map-list');
        $(".classes-list .class-listing")
            .sort(function (a, b) { return +$(b).data(sortBy) < +$(a).data(sortBy) ? 1 : -1; })
            .appendTo('.classes-list');
        $('.class-listing').first().click();
    });

    return map;
}

var pinotStyle = [
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    }
];
// FixedSticky.tests.sticky = false;
jQuery(function($) {
  var $window = $(window);
  var $body = $('body');
  var $mobileMenu = $('.mobile-menu');
  var $metaNav = $('.page-container > .meta-nav');
  var $primaryNav = $('nav.primary-nav');
  var $header = $('.page-container > header.header');

	riot.mount('*');

  $("form.signup").validate();

  $(".loyalty form").validate();

  $("form.login").validate();
  
  $(".js-checkoutFormValidate").validate({
    rules: {
      Email: {
        required: true,
        email: true
      }
    }
  });
  
  $('.lp-form form').validate({
    rules: {
      Email: {
        required: true,
        email: true
      }
    }
  });

  jQuery('a.share, p.share a').BEShare({
    'type': 'popup', // or 'inline'
    'targets': ['Facebook', 'Twitter', 'LinkedIn', 'Google+', 'Print', 'Email'],
    'class': 'BEShare',
    'prefix': 'icon-',
    'width': '626',
    'height': '436',
    'onShare': null,
    'altLink': true
  });

  $('a:not(.lightbox)[href^="#"]').on('click',function(e) {
    if ($(e.target).parent('li').parent('ul.tabs').length) {
      // This is tab, don't scroll.
      return true;
    }

    e.preventDefault();
    var target = this.hash;

    if(this.hash === "#body") {
      target = "body";
    }

    var $target = $(target);

    if($target.length > 0) {
      var top = $target.offset().top;

      $('html, body').stop().animate({
        'scrollTop': top
      }, 500, 'swing');
    }
  })

  //Toggle Mobile Party additional fields
  $(".party-form form").each(function() {
    $(this).find("#event-type select").change(function(){
      var $mobile = $(".party-form form .mobile");
      var $stationary = $(".party-form form .stationary");
      if($(this).val() === "Mobile") {
        if(!$mobile.hasClass("active")) {
          $mobile.addClass("active");
          $stationary.removeClass("active");
        }
      } else {
        if(!$stationary.hasClass("active")) {
          $stationary.addClass("active");
          $mobile.removeClass("active");
        }
      }
    })
  });

  // Prevent the page to scroll on mobile menu.
  $('input#mobile-menu-toggle').change(function() {
    $('body').css({
      'position': 'relative',
      'overflow': this.checked? 'hidden' : ''
    });
  });

  $('#lightbox .close').click(function(){
    $(this).parent().parent().css('display','none');
  });

  $('.tabs').each(function() {
    var $tabContainer = $(this);
    var $tabs = $tabContainer.find('li');
    var $panes = $tabContainer.siblings('.tab-panes').children();

    // Open the tab that is marked active from the markup first.
    var index = $tabs.index($tabs.filter('.active'));
    $panes.eq(0).css('margin-left', -1 * index * 100 + '%');
    $panes.removeClass('active').eq(index).addClass('active');

    $tabContainer.on('click', 'li', function() {
      var $tab = $(this), href = $tab.find('a').attr('href');

      if (href && href.indexOf('#') === 0) {
        // This is actual tab.
        $tabs.removeClass('active');
        $tab.addClass('active');

        index = $tabs.index($tab);
        var $pane = $panes.removeClass('active').eq(index).addClass('active');

        $panes.eq(0).css('margin-left', -1 * index * 100 + '%');

        // There must be a better way to trigger scroll event so that
        // the lazy-loaders can run.
        window.scrollBy(0,1);
        window.scrollBy(0,-1);
      }
    });

    if(window.location.hash) {
      var $selectedTab = $tabs.find("[href$="+window.location.hash+"]").parent();
      if($selectedTab.length > 0) {
        $('html, body').stop().animate({
          'scrollTop': $selectedTab.offset().top
        }, 500, 'swing');

      }
    }
  });

  // Mobile menu
  function mobileSecondarNav() {
    $primaryNav.find('> ul > li > a').each(function() {
      var $navLink = $(this), $secondaryNav = $navLink.next('.secondary-nav');
      if (!$secondaryNav.length) return;

      $navLink.on('click.secondary-nav', function(event) {
        if (!$mobileMenu.is(':visible')) return;

        event.preventDefault();
        $navLink.toggleClass('selected');
      });
    });
  }

  // $window.on('resize.secondary-nav orientationchange.secondary-nav', mobileSecondarNav);
  mobileSecondarNav();

  // Filters
  $(".filter").each(function() {
    var $filter = $(this),
        name = $filter.prop('name'),
        selector = name.replace(/(\[|\]|\.)/g, '\\$1'),
        target = $filter.attr('data-target') || 'body',
        $target = $(target),
        $items = $('[data-'+selector+'], [data-filter-name="'+name+'"]', $target);
    
    var value = this.value;
    if (value) {
      $items.css({
        'display': 'none'
      })
      .filter('[data-'+selector+'="'+value+'"], [data-filter-value="'+value+'"]').css({
        'display': ''
      });
    } else {
      $items.css({
        'display': ''
      });
    }

    $filter.on('change', function() {
      value = this.value;
      $items = $('[data-'+selector+'], [data-filter-name="'+name+'"]', $target)
      if (value) {
        $items.css({
          'display': 'none'
        })
        .filter('[data-'+selector+'="'+value+'"], [data-filter-value="'+value+'"]').css({
          'display': ''
        });
      } else {
        $items.css({
          'display': ''
        });
      }

      // Triggers update for Riot tags that can be affected by the
      // show and hide of this filter, such as collapsibles.
      riot.update();
    });
  });
  
  
   

  var oldWindowWidth, oldOrientation;
  function adjustOffset() {
    var newWindow = $window.width(), newOrientation = window.orientation;
    if(newWindow === oldWindowWidth || (newOrientation && newOrientation === oldOrientation)) {
      return;
    }
    oldWindowWidth = newWindow;
    oldOrientation = newOrientation;

    var top;

    if ($mobileMenu.is(':visible')) {
      top = $metaNav.outerHeight(true);
    } else {
      top = $header.outerHeight(true);
    }

    var scrollTop = $window.scrollTop();

    $('.fixedsticky').each(function() {
      var $el = $(this),
          $offsetEl = $($el.attr('data-offset')),
          offset = $offsetEl.offset();

      var top = (offset && (offset.top + $offsetEl.outerHeight(true))) || 0;
      if (!$offsetEl.is(':visible')) {
        top = 0;
      } else if (['fixed', 'sticky', '-webkit-sticky'].indexOf($offsetEl.css('position')) > -1) {
        top -= scrollTop;
      }
      if (top != parseInt($el.attr('data-top'))) {
        $el.css('top', top + 'px');
        $el.attr('data-top', top);

        $el.next('.fixedsticky-dummy').height($el.outerHeight(true));
      }
        $el.fixedsticky( 'destroy' );
        $el.fixedsticky();
    });
  }

  var scrollTimer, lastScrollTop = 0;;
  function handleBodyScroll() {
    clearTimeout(scrollTimer);
    var scrollTop = $window.scrollTop();

    if (scrollTop > lastScrollTop && !$body.hasClass('scrolling-down')) {
      $body.removeClass('scrolling-up').addClass('scrolling-down');
    }
    if (scrollTop < lastScrollTop && !$body.hasClass('scrolling-up')) {
      $body.removeClass('scrolling-down').addClass('scrolling-up');
    }

    scrollTimer = setTimeout(function(){
      $body.removeClass('scrolling-up').removeClass('scrolling-down');
    }, 500);

    $('.fixedsticky').each(function() {
      var $el = $(this), offset = parseInt($el.attr('data-top'));
      // $el.toggleClass('sticked', $el.offset().top - scrollTop <= offset);
      $el.toggleClass('sticked', scrollTop > offset);
    });

    lastScrollTop = scrollTop;
  }

  adjustOffset();
  handleBodyScroll();

  $('.fixedsticky').each(function() {
    $(this).fixedsticky();
  });

  $window.on('resize.pinots orientationchange.pinots', adjustOffset);
  // window.setInterval(adjustOffset, 50);
  $window.on('scroll.pinots', handleBodyScroll);

  // Anchor link animate
  $('.fold-down').click(function(){
    $('html, body').animate({
        scrollTop: $( $.attr(this, 'href') ).offset().top
    }, 500);
    return false;
  });

  //Loyalty form input labels
  // $('.loyalty form').each(function(){
  //   $(this).find("fieldset.input input").on
  // })

  // $('header.header').each(function() {
  //   var $header = $(this), $container = $header.parent('.page-container');
  //   $container.css({
  //     'padding-top': $header.height()
  //   });

  //   $(window).resize(function() {
  //     if ($header.css('position') === 'relative') {
  //       // Mobile
  //       $container.css('padding-top', '');
  //       var $mobileHeader = $header.find('.container');

  //       $mobileHeader.parent().css({
  //         'position': 'fixed'
  //       })
  //     }
  //   });
  // });

  function isElementInViewport (el) {
    var rect = el.getBoundingClientRect();

    return rect.bottom > 0 &&
        rect.right > 0 &&
        rect.left < (window.innerWidth || document. documentElement.clientWidth) /*or $(window).width() */ &&
        rect.top < (window.innerHeight || document. documentElement.clientHeight) /*or $(window).height() */;
  }

  function adjustTop() {
    var $mobileMenu = $('.mobile-menu');
    var $metaNav = $('.page-container > .meta-nav');
    var $header = $('.page-container > header.header');
    var $locationForm = $('.sticky.studio-form');
    var top;

    if ($mobileMenu.is(':visible')) {
      top = $metaNav.is(':visible') 
            ? $metaNav.outerHeight(true)
            // The meta nav is hidden on larger lanscape mobile,
            // So we set the top to 0 here. The state name will
            // add the height of the form so it would be correct.
            : 0;
    } else {
      top = $header.outerHeight(true);
    }

    Stickyfill.pause();
    $locationForm.each(function() {
      var $el = $(this);
      if ($el.css('position') !== 'absolute') {
        $el.css('top', top + 'px');
      }
      // setTimeout(function() {
      //   $el.Stickyfill();
      // }, 1);
      // $el.Stickyfill();
      Stickyfill.add(this);
    });

    $('.sticky.state-name').each(function() {
      var $el = $(this);
      var visible = isElementInViewport($el.parent()[0]);
      $el.toggleClass('visible', visible)
      if (visible) {
        if ($el.css('position') !== 'absolute') {
          $el.css('top', top + $locationForm.outerHeight(true) + 'px');
        }
        //Stickyfill.add(this);
      } else {
        //Stickyfill.remove(this);
      }
      setTimeout(function() {
        if (visible) {
          Stickyfill.add($el[0]);
        } else {
          Stickyfill.remove($el[0]);
        }
      }, 1);
    });

    Stickyfill.init();
  }

  function toggleClass() {
    var scrollTop = $window.scrollTop();

    $('.sticky').each(function() {
      var $el = $(this), offset = parseInt($el.attr('data-top'));
      $el.toggleClass('sticked', $el.offset().top - scrollTop <= offset);
    });
  }

  // Set up polyfill for `position: sticky` with optional offset.
  adjustTop();

  $window.on('DOMContentLoaded load resize orientationchange hashchange scroll', adjustTop);
  // $window.on('hashchange', adjustTop);

  // $('.back-to-top').fixedsticky();
  
  
  
  $('.qtyplus').on('click',function(e){
       // Stop acting like a button
       e.preventDefault();
       // Get the field name
       fieldName = $(this).attr('field');
       var fieldID = $(this).data('id');
       // Get its current value
       var currentVal = parseInt($('input#'+fieldID+'[name="'+fieldName+'"]').val());
       // If is not undefined
       if (!isNaN(currentVal)) {
           // Increment
           $('input#'+fieldID+'[name="'+fieldName+'"]').val(currentVal + 1);
       } else {
           // Otherwise put a 0 there
           $('input#'+fieldID+'[name="'+fieldName+'"]').val(0);
       }
   });
   // This button will decrement the value till 0
   $(".qtyminus").on('click',function(e) {
       // Stop acting like a button
       e.preventDefault();
       // Get the field name
       fieldName = $(this).attr('field');
       var fieldID = $(this).data('id');
       // Get its current value
       var currentVal = parseInt($('input#'+fieldID+'[name="'+fieldName+'"]').val());
       // If it isn't undefined or its greater than 0
       if (!isNaN(currentVal) && currentVal > 0) {
           // Decrement one
           $('input#'+fieldID+'[name="'+fieldName+'"]').val(currentVal - 1);
       } else {
           // Otherwise put a 0 there
           $('input#'+fieldID+'[name="'+fieldName+'"]').val(0);
       }
   });
   
   
   $(".js-calendarSwitcher").on('click',function() {
       
        $('.js-calendar').toggleClass('cal-list-view');
        $('.js-calendarHeader').toggleClass('cal-list-view');
        $(this).toggleClass('cal-list-view');
        
        if($('.js-calendar').hasClass('private')){
            $('.calendar .calendar-date.empty-private').show();
            $('.calendar.cal-list-view .calendar-date.empty-private').hide();
        }
        else
        {
            $('.calendar .calendar-date.empty-private').show();
        }
        
        if($('.js-calendar').hasClass('cal-list-view')){
            $('.tooltipster').tooltipster('disable');
        }
        else{
            $('.tooltipster').tooltipster('enable');
            
        }
   });
   
   function shouldRun(className){
        return document.body.classList.contains(className);
    }
    
    if(shouldRun('event-calendar')){
        var days = $('.js-calendarHeader');
        var hieghtThreshold = $(".js-calendar").offset().top;
        var hieghtThreshold_end  = $(".js-calendar").offset().top +$(".js-calendar").height() ;
    
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();
        
            if (scroll >= hieghtThreshold && scroll <=  hieghtThreshold_end ) {
                days.addClass('stick');
            } else {
                days.removeClass('stick');
            }
        });
    }
    
    function eventsToggle(){
        $('.js-toggleEvents').on('click',function(e){
             e.preventDefault();
             var id = $(this).attr('id');
             var windowsize = $(window).width();
             
             $('.js-toggleEvents').removeClass('calendar-toggle__item--active');
             $(this).addClass('calendar-toggle__item--active');
             
             if(window.matchMedia('(max-width: 1023px)').matches){
                 $('.calendar .calendar-date.empty-private').hide();
             }
             
             if(id == 'private-events-toggle'){
                 $('.calendar .events .event[data-event-type="Public"]').hide();
                 $('.calendar .events .event[data-event-type="Private"]').show();
                 $('.js-calendar').addClass('private');
                 
                 if( $('.js-calendar').hasClass('cal-list-view') || window.matchMedia('(max-width: 1023px)').matches ){
                     $('.calendar .calendar-date.empty-private').hide();
                 }
                 else{
                     $('.calendar.cal-list-view .calendar-date.empty-private').show();
                 }
                 $('.calendar .calendar-date.empty-public').show();

                 if (document.getElementById("no-public-events"))
                     $('ol').removeClass("no-public-events");

                 setEventCalendarLink("events-next-month-bottom", true);
                 setEventCalendarLink("events-prev-month-top", true);
                 setEventCalendarLink("events-prev-month-bottom", true);
             }
             if(id == 'public-events-toggle'){
                 $('.calendar .events .event[data-event-type="Public"]').show();                 
                 $('.calendar .events .event[data-event-type="Private"]').hide();                 
                 $('.js-calendar').removeClass('private');

                 if( $('.js-calendar').hasClass('cal-list-view') || window.matchMedia('(max-width: 1023px)').matches ){
                     $('.calendar .calendar-date.empty-public').hide();
                 }
                 else{
                     $('.calendar.cal-list-view .calendar-date.empty-public').show();
                 }                 
                 $('.calendar .calendar-date.empty-private').show();

                 if (document.getElementById("no-public-events"))
                     $('ol').addClass("no-public-events");

                 setEventCalendarLink("events-next-month-bottom", false);
                 setEventCalendarLink("events-prev-month-top", false);
                 setEventCalendarLink("events-prev-month-bottom", false);
             }
         });    
    }

    function setEventCalendarLink(selector, isPrivate){
        var link = $("#" + selector).attr("href");        
        if (isPrivate && !endsWith(link, "/private")){            
            $("#" + selector).attr("href", link + '/private');
        }
        if (!isPrivate && endsWith(link, "/private")){
            $("#" + selector).attr("href", link.replace('/private', ''));
        }
    }
    function endsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }

  function tooltipsterInit(){
      
        $('.tooltipster').tooltipster({
            theme: ['tooltipster-light', 'tooltipster-customized'],
            side: ['top', 'bottom'],
            multiple: true
        });
        
        if (windowsize >= 1024){
            $('.tooltipster').tooltipster('enable');
        }
        else{
            $('.tooltipster').tooltipster('disable');
        }
      
  }
  
  function tooltipsteAlwaysInit(){
        $('.tooltipster-always').tooltipster({
            theme: ['tooltipster-light', 'tooltipster-customized'],
            side: ['top', 'bottom'],
            multiple: true
        });
  }

  function tooltipster() {
      var windowsize = $(window).width();
      
      if (windowsize >= 1024){
          $('.tooltipster').tooltipster('enable');
     }
     else
     {
         $('.tooltipster').tooltipster('disable');
     }

  }
  
     
    $('.js-toggleBtn').on('click',function(e){
        e.preventDefault();
        
        var container = $(this).data("container");
        var openText = $(this).data("open-text");
        var hideText = $(this).data("hide-text");
        
        $('#'+container).slideToggle();
        $(this).toggleClass('active');
        
        if(openText != ''){
            $(this).text(function(i, text){
                return text === openText ? hideText : openText;
            })
        }
    });
    
    $('#PrimaryPhone').inputmask({"mask": "9999999999"});
    
  function showFrameOptions(){
    $('.js-frameOptionsLaunch').on('click',function(e){
          e.preventDefault();
          
          var class = $(this).data("class");
          
          $(class).toggle();
          $(this).toggleClass('active');
    });
    $('.js-cancelFrames').on('click',function(e){
         e.preventDefault();
         
         var class = $(this).data("class");
          
          $(class).hide();
          $('.js-frameOptionsLaunch').removeClass('active');
    });
  }
  
  function launchCollapse(){
      $('.js-buttonCollapseLauncher').on('click',function(){
          $('body').addClass('collapse-open');
          $(this).toggleClass('active');
      });
      
      $('.js-collapser').on('click',function(){
          $('body').removeClass('collapse-open');
          $('.js-buttonCollapseLauncher').removeClass('active');
      });
      
/*
      $('.js-submitClose').on('click',function(){
          $('body').removeClass('collapse-open');
          $(this).parent().parent().parent().removeClass('open');
      });
*/
  }
  
  var windowsize = $(window).width();
      
  tooltipsterInit();
  tooltipsteAlwaysInit();
  eventsToggle();
  showFrameOptions();
  launchCollapse();
  
  $(window).resize(function() {
      
       var windowsize = $(window).width();
       
       tooltipster();
       eventsToggle();
   });

});



jQuery(window).on('load', function() {
  var $ = jQuery, $window = $(window);

  function adjustOffsetOld() {
    // This is run before Stickyfill's handlers.
    var scrollTop = $window.scrollTop();

    $('.sticky').each(function() {
      var $el = $(this),
          $offsetEl = $($el.attr('data-offset')),
          $from = $($el.attr('data-from')),
          offset = $offsetEl.offset(),
          top = 0;

      if ($offsetEl.length) {
        // $offsetEl.each(function() {
        //   var $this = $(this);

        //   // if ($this.is(':visible')) {
        //     if (['fixed', 'sticky', '-webkit-sticky', 'static'].indexOf($this.css('position')) > -1) {
        //     top += $this.offset().top;
        //     top += $this.outerHeight(true);
        //       top -= scrollTop;
        //     }
        //   // }

        // });
        top = (offset.top + $offsetEl.outerHeight(true)) || 0;
        if (['fixed', 'sticky', '-webkit-sticky'].indexOf($offsetEl.css('position')) > -1) {
          top -= scrollTop;
        }
      } else {
        offset = $from.offset();
        top = offset.top;
      }

      console.log(top)

      // var top = (offset && (offset.top + $offsetEl.prop('scrollHeight'))) || 0;
      // if (['fixed', 'sticky', '-webkit-sticky'].indexOf($offsetEl.css('position')) > -1) {
      //   top -= scrollTop;
      // }

      // Only adjust when offset does change.
      if (top != parseInt($el.attr('data-top')) ) {
        $el.attr('data-top', top);
        // $el.Stickyfill();

        // When resized, if the element is not sticked (not absolute
        // positioned by Stickyfill), then we set new top for sticky.
        if ($el.css('position') !== 'absolute') {
          $el.css('top', top + 'px');
        }
      }

      if ($el.hasClass('widget')) {
        // console.log(top, $offsetEl[0].scrollHeight);
      }

      setTimeout(function() {
        if ($el.css('position') === 'fixed') {
          $el.css('top', top + 'px');
        }
      }, 50);
    });

  }

  // function adjustTop() {
  //   var $mobileMenu = $('.mobile-menu');
  //   var $metaNav = $('.page-container > .meta-nav');
  //   var $header = $('.page-container > header.header');
  //   var $locationForm = $('.sticky.studio-form');
  //   var top;

  //   if ($mobileMenu.is(':visible')) {
  //     top = $metaNav.outerHeight(true);
  //   } else {
  //     top = $header.outerHeight(true);
  //   }

  //   Stickyfill.kill();

  //   $locationForm.each(function() {
  //     var $el = $(this);
  //     $el.css('top', top + 'px');
  //     // setTimeout(function() {
  //     //   $el.Stickyfill();
  //     // }, 1);
  //   });

  //   $('.sticky.state-name').each(function() {
  //     var $el = $(this);
  //     $el.css('top', top + $locationForm.outerHeight(true) + 'px');
  //     // setTimeout(function() {
  //     //   $el.Stickyfill();
  //     // }, 1);
  //   });

  //   setTimeout(function() {
  //     $('.sticky').Stickyfill();
  //   }, 1);
  // }

  // function toggleClass() {
  //   var scrollTop = $window.scrollTop();

  //   $('.sticky').each(function() {
  //     var $el = $(this), offset = parseInt($el.attr('data-top'));
  //     $el.toggleClass('sticked', $el.offset().top - scrollTop <= offset);
  //   });
  // }

  // // Set up polyfill for `position: sticky` with optional offset.
  // adjustTop();
  // // toggleClass();
  // $('.sticky').each(function() {
  //   $(this).Stickyfill();

  // });

  // $window.on('resize orientationchange', adjustTop);
  // $window.on('hashchange', adjustTop);
  // window.setInterval(adjustOffset, 100);
  // $window.scroll(adjustOffset);
  // $window.scroll(toggleClass);

  // var $headers = $('body.franchise header.header, header.header .container');
  var $headers = $('body.franchise1 header.header, header.header1 .container');
  function stickHeaders() {
    $headers.each(function() {
      var $header = $(this), $container = $header.parent();

      if ($header.css('position') === 'fixed') {
        $container.css('padding-top', $header.height());
      } else {
        $container.css('padding-top', '');
      }
    })
  }
  $window.resize(stickHeaders);
  stickHeaders();

  // $window.scroll(function() {
  //   var $franchiseHeader = $('body.franchise header.header');

  //   if ($franchiseHeader.css('position') === 'fixed') {
  //     var scrollTop = $window.scrollTop();
  //     console.log(scrollTop, $franchiseHeader.offset().top)
  //     if (scrollTop > 0) {
  //       $franchiseHeader
  //     }
  //   }
  // });
  
  
});

riot.tag2('infinite-scroller', '<div name="container"><yield></yield></div><raw-tag each="{child in visibles}" data="{child}"></raw-tag>', '', '', function(opts) {
    this.on('mount', function() {
        var children = [];
        Array.prototype.push.apply(children, Array.prototype.slice.call(this.container.children));

        var visibles = this.visibles = [];

        children.forEach(function(child) {
            visibles.push({
                html: child.outerHTML
            });
        });

        this.update();
    });
});

riot.tag2('raw-tag', '', '', '', function(opts) {
    this.root.innerHTML = this.opts.data.html;
});

riot.tag2('lazy-loader', '<yield></yield>', '', '', function(opts) {
    this.mixin('Selectors');
    var $ = this.$;
    var self = this;

    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                                   || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    var handlerRunning = false;
    function eventThrottler() {
        if ( !handlerRunning ) {
            handlerRunning = true;
            if (window.requestAnimationFrame) {
                window.requestAnimationFrame(handler);
            } else {
                setTimeout(handler, 66);
            }
        }
    }

    function handler() {
        var items = self.items;
        var count = items.length;

        for(var i = items.length; i--;) {

            (function(index) {
                var el = items[index];
                var url = el.getAttribute(opts.attr);
                if (url) {
                    if($.visible(el)) {
                        el.setAttribute('src', url);
                        el.removeAttribute(opts.attr);
                        items.splice(index, 1);
                        return;
                    }
                } else {

                }
            })(i);

        }

        if (items.length <= 0) {
            $.off(window, 'load scroll resize', eventThrottler);
        }

        handlerRunning = false;
    }

    this.on('mount', function() {
        var embeddeds = this.root.querySelectorAll('[' + opts.attr + ']');
        this.items = Array.prototype.slice.call(embeddeds);
    });

    $.on(window, 'load scroll resize', eventThrottler);
});

function primaryLinkClicked(obj) {
    if (!obj.classList.contains("selected")) return;
    document.location = obj.href;
}
riot.tag2('ajax-request', '', '', '', function(opts) {


    var previousUrl, previousParams;
    this.on('update', function() {
      var url = opts.url, params = opts.params;

      if (!url) { return; }
      if (url === previousUrl) {
        if (!params || (params === previousParams)) { return; }
      }
      this.request();
      previousUrl = url;
      previousParams = params;
    });

    this.request = function() {
      var url = opts.url,
          method = opts.method || 'GET'
          params = opts.params || '';

      if (params && (method === 'GET' || method === 'get')) {
        url += (url.indexOf('?') >= 0 ? '&' : '?');
        url += params;
      }
      var xhr = this.xhr = new XMLHttpRequest();
      xhr.addEventListener('load', this.onload);
      xhr.open(opts.method || 'GET', url);

      if (method === 'POST' || method === 'post') {
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.send(params);
      } else {
        xhr.send();
      }
    }.bind(this)

    this.on('request', this.request);

    this.onload = function() {
      var xhr = this.xhr;
      if (xhr.readyState !== xhr.DONE) return;
      if (xhr.status !== 200) {
        var error = new Error('XMLHttpRequest failed with status' + xhr.status);
        this.trigger('error', error);
        throw error;
        return;
      }

      var response;
      switch (opts.type) {
        case 'text':
          response = xhr.responseText;
          break;
        case 'xml':
          response = xhr.responseXML;
          break;
        case 'arraybuffer':
        case 'blob':
        case 'document':
          response = xhr.response;
          break;
        case 'json':
        default:
          response = JSON.parse(xhr.responseText);
          break;
      }

      this.trigger('response', response);
    }.bind(this)

});
riot.tag2('better-select', '<div name="selected-option" onclick="{toggle}"></div><div name="options" if="{show}" onclick="{select}"><yield from="options"></yield></div><span class="{opts.toggleClass}" onclick="{toggle}"></span>', 'better-select > div,[riot-tag="better-select"] > div,[data-is="better-select"] > div{ display: inline-block; }', '', function(opts) {
    this.mixin('Selectors');

    var self = this, element = self.root;
    this.show = false;

    this.toggle = function(event) {
      this.show = !this.show;

      event.stopPropagation();
    }.bind(this)

    this.select = function(event) {
      var target = event.target;
      var option = self.$.closest(target, function(el) {

        return el.parentNode === self.options;
      });

      if (option) {
        self.selection = option;
        self['selected-option'].innerHTML = option.innerHTML;
      }
      return true;
    }.bind(this)

    this.on('mount', function() {
      var selectedIndex = parseInt(opts.option || '0');
      var options = Array.prototype.slice.call(this.options.children);
      self.selection = options[selectedIndex];
      self['selected-option'].innerHTML = self.selection.innerHTML;
    });

    document.addEventListener('click', function() {

      self.show = false;
      self.update();
    });

});
riot.tag2('blog-filter', '<yield></yield><div if="{pages.length > 1}" class="pagination"><a onclick="{prev}" class="prev icon-left-circled"></a><ul class="pages"><li each="{page, i in pages}"><a class="{active: i===parent.activeIndex}" onclick="{parent.pageControl}">{page}</a></li></ul><a onclick="{next}" class="next icon-right-circled"></a></div>', 'blog-filter .hidden-list,[riot-tag="blog-filter"] .hidden-list,[data-is="blog-filter"] .hidden-list{ display: none; } blog-filter ul.pages,[riot-tag="blog-filter"] ul.pages,[data-is="blog-filter"] ul.pages{ display: inline; } blog-filter ul.pages li,[riot-tag="blog-filter"] ul.pages li,[data-is="blog-filter"] ul.pages li{ display: inline; list-style: none; margin:0; }', '', function(opts) {

    var el = this.root, self = this, indexedItems = [];

    this.activeIndex = 0;
    this.pages = [];

    this.pageControl = function(event) {
      self.changePage(event.item.i);
    }.bind(this)

    this.next = function(event) {
      if(self.activeIndex+1 < self.pages.length ) {
        self.changePage(self.activeIndex+1);
      }
    }.bind(this)

    this.prev = function(event) {
      if(self.activeIndex-1 >= 0 ) {
        self.changePage(self.activeIndex-1);
      }
    }.bind(this)

    this.changePage = function(page) {
      for(var i = 0; i < indexedItems.length; i++) {
        indexedItems[i].style.display = "none";
      }

      for(var i = page*self.opts.items; i < indexedItems.length && i < page*self.opts.items+parseInt(self.opts.items); i++) {
        indexedItems[i].style.display = "inline-block";
      }

      self.activeIndex = page;
    }.bind(this)

    this.on('mount', function() {
      indexedItems = el.querySelectorAll(self.opts.selector);
      pagesElem = el.querySelector(".pages");

      pagesCount = Math.ceil(indexedItems.length / self.opts.items);
      self.pages = Array.apply(null, Array(pagesCount)).map(function (_, i) {return i+1;});
      self.changePage(0);

      self.update();
    });

});
riot.tag2('cloned-placeholder', '<yield></yield>', 'cloned-placeholder .cloned,[riot-tag="cloned-placeholder"] .cloned,[data-is="cloned-placeholder"] .cloned{ visibility: hidden; opacity: 0; }', '', function(opts) {
    var element = this.root;
    var targets = document.querySelectorAll(opts.from);
    var position = opts.position || 'prepend';

    var i = 0, l = targets.length;

    function clone(index, targets) {
      var node = targets[index];
      var cloned = node.cloneNode(true);
      cloned.className += ' cloned';
      return cloned;
    }

    if (position === 'prepend') {
      while (l--) {
        var cloned = clone(l, targets);
        element.insertBefore(cloned, element.firstChild);
      }
    } else if (position === 'append') {
      for (i; i<l; i++) {
        var cloned = clone(i, targets);
        element.appendChild(cloned);
      }
    }
});
riot.tag2('collapsible-set', '<a class="{open: !collapsed, close: collapsed}" href="#" onclick="{toggle}" name="header"></a><div aria-hidden="{collapsed? \'true\' : \'false\'}" name="content" class="{open: !collapsed, close: collapsed}"><yield></yield><div if="{opts.close}" class="close" onclick="{toggle}"></div></div>', 'collapsible-set a[name="header"],[riot-tag="collapsible-set"] a[name="header"],[data-is="collapsible-set"] a[name="header"]{ text-decoration: none; color: inherit; }', '', function(opts) {


    var self = this, element = self.root;
    this.collapsed = opts.collapsed;

    this.updateOpenHeight = function() {
      var height = self.content.scrollHeight;
      self.content.style.maxHeight = height + 'px';
    }.bind(this)

    this.updateCloseHeight = function() {
      var height = 0;
      if (opts.offset) {
        var offset = element.querySelector(opts.offset);
        if (offset) {
          height += offset.offsetTop + offset.offsetHeight;
        }
      }
      self.content.style.maxHeight = height + 'px';
    }.bind(this)

    this.on('mount', function() {
      var header = element.querySelector(opts.heading);
      var parentNode = header.parentNode;
      var index = Array.prototype.indexOf.call(parentNode.children, header);
      parentNode.removeChild(header);

      this.header.innerHTML = header.innerHTML;
      header.innerHTML = "";
      header.appendChild(this.header);

      if (index === 0) {
        element.insertBefore(header, element.firstChild);
      } else {
        element.appendChild(header);
      }

      if (opts.trigger) {
        var triggers = document.querySelectorAll(opts.trigger),
            count = triggers.length, trigger;
        while (count--) {
          triggers[count].addEventListener('click', this.toggle);
        }
      }
    });

    this.on('update', function() {
      var content = this.content;
      if (this.collapsed) {

        setTimeout(function() {
          self.updateCloseHeight();
        }, 0);

        return;
      }

      setTimeout(function() {
        self.updateOpenHeight();
      }, 0);
    });

    window.addEventListener('resize', function() {
      if (self.collapsed) {
        self.updateCloseHeight();
        return;
      };
      self.updateOpenHeight();
    });

    this.toggle = function() {
      this.collapsed = !this.collapsed;
      this.update();
    }.bind(this)
});


riot.tag2('collapsible-behavior', '<a onclick="{toggle}" riot-tag="raw-html" content="{opts.heading}"></a><div class="content {collapse:collapsed}"><yield></yield></div>', 'collapsible-behavior .content,[riot-tag="collapsible-behavior"] .content,[data-is="collapsible-behavior"] .content{ max-height: 500px; overflow: hidden; transition: max-height 0.25s ease-in-out; } collapsible-behavior .content.collapse,[riot-tag="collapsible-behavior"] .content.collapse,[data-is="collapsible-behavior"] .content.collapse{ max-height: 0; }', '', function(opts) {

  	this.collapsed = true;

  	this.toggle = function() {
	  	if(opts.onselect) {
		  	opts.onselect(this);
	  	}

	  	if(this.collapsed) {
		  	this.open();
	  	} else {
		  	this.close();
	  	}
  	}.bind(this)

  	this.close = function() {
	  	this.collapsed = true;
	  	this.update();
  	}.bind(this)

		this.open = function() {
			this.collapsed = false;
			this.update();
		}.bind(this)

});

riot.tag2('accordion-behavior', '<yield></yield>', '', '', function(opts) {

		this.index = null;

		var self = this;

		this.syncChildren = function(item) {
			if(this.index !== null) {
				this.index.close();
			}
			this.index = item;
		}.bind(this)

		this.tags["collapsible-behavior"].forEach(function(item, index) {
			item.opts.onselect = self.syncChildren;
		})

});

riot.tag2('raw-html', '', '', '', function(opts) {
	this.on('update', function() {
		this.root.innerHTML = opts.content
	});
});
riot.tag2('content-slider', '<a name="left" if="{pages.length > 1}" class="{⁗backward⁗: true, ⁗disabled⁗: activeIndex <= 0}" href="#slide-{activeIndex - 1}" onclick="{backward}"><span class="icon-left-open-big"></span><span class="sr-only">Go Left</span></a><div class="viewport"><yield></yield></div><a name="right" if="{pages.length > 1}" class="{⁗forward⁗: true, ⁗disabled⁗: activeIndex >= pages.length - 1}" href="#slide-{activeIndex + 1}" onclick="{forward}"><span class="icon-right-open-big"></span><span class="sr-only">Go Right</span></a><nav><a each="{page, index in pages}" href="#" onclick="{goto}" class="{⁗thumbnail⁗: parent.opts.thumbnail}"><span class="{⁗icon-circle⁗: index == activeIndex, ⁗icon-circle-empty⁗: index != activeIndex}"><img if="{parent.opts.thumbnail}" riot-src="{parent.opts.thumbnail? page : null}"></span><span class="sr-only">Go to Slide</span></a></nav>', 'content-slider,[riot-tag="content-slider"],[data-is="content-slider"]{ position: relative; display: block; } content-slider .viewport,[riot-tag="content-slider"] .viewport,[data-is="content-slider"] .viewport{ position: relative; display: block; white-space: nowrap; overflow: hidden; margin-bottom: 1em; } content-slider .viewport > ul,[riot-tag="content-slider"] .viewport > ul,[data-is="content-slider"] .viewport > ul{ letter-spacing: -.31em; position: relative; left: 0%; -webkit-transition: all .25s ease-in-out; -moz-trasition: all .25s ease-in-out; -ms-transition: all .25s ease-in-out; -o-transitionsition: all .25s ease-in-out; transition: all .25s ease-in-out; margin: 0; } content-slider .viewport > ul > li,[riot-tag="content-slider"] .viewport > ul > li,[data-is="content-slider"] .viewport > ul > li{ display: inline-block; vertical-align: middle; letter-spacing: normal; white-space: normal; list-style: none; } content-slider .viewport > ul > li figure > img,[riot-tag="content-slider"] .viewport > ul > li figure > img,[data-is="content-slider"] .viewport > ul > li figure > img,content-slider .viewport > ul > li figure > a > img,[riot-tag="content-slider"] .viewport > ul > li figure > a > img,[data-is="content-slider"] .viewport > ul > li figure > a > img{ width: 100%; height: auto; display: block; } content-slider nav,[riot-tag="content-slider"] nav,[data-is="content-slider"] nav{ text-align: center; position: absolute; top: 100%; left: 0; width: 100%; } content-slider .backward,[riot-tag="content-slider"] .backward,[data-is="content-slider"] .backward,content-slider .forward,[riot-tag="content-slider"] .forward,[data-is="content-slider"] .forward{ position: absolute; top: 0; bottom: 0; height: 100%; font-size: 4em; z-index: 1; color: black; } content-slider .backward,[riot-tag="content-slider"] .backward,[data-is="content-slider"] .backward{ left: 0%; } content-slider .forward,[riot-tag="content-slider"] .forward,[data-is="content-slider"] .forward{ right: 0%; } content-slider .backward:before,[riot-tag="content-slider"] .backward:before,[data-is="content-slider"] .backward:before,content-slider .forward:before,[riot-tag="content-slider"] .forward:before,[data-is="content-slider"] .forward:before{ content: \'\'; display: inline-block; height: 100%; vertical-align: middle; } content-slider .backward > span:before,[riot-tag="content-slider"] .backward > span:before,[data-is="content-slider"] .backward > span:before,content-slider .forward > span:before,[riot-tag="content-slider"] .forward > span:before,[data-is="content-slider"] .forward > span:before{ width: auto; }', '', function(opts) {
    this.slides = [];
    this.pages = [];

    this.activeIndex = parseInt(opts.slide || '0');
    var element = this.root, self = this, viewport, containers;

    this.on('mount', function() {
      viewport = element.querySelector('.viewport');
      containers = element.querySelectorAll('.viewport > ul');

      if(this.opts.radio) {
        var radios = element.querySelectorAll(this.opts.radio);

        for(var i = 0; i<radios.length; i++) {
          radios[i].addEventListener("change",function(){

            self.clearSelect();
            this.parentNode.parentNode.parentNode.classList.add("selected");
          })
        }
      }

      this.paginate();
      this.go();
      this.performSelect();
      this.update();
      this.moveNavs();
      this.resetTimer();
    });

    this.clearSelect = function() {
      var slides = element.querySelectorAll(".viewport > ul > li");
      for(var i = 0; i < slides.length; i++) {
        slides[i].classList.remove("selected");
      }
    }.bind(this)

    this.performSelect = function() {
      if (this.visibleSlides === 1 && this.opts.radio) {
        var slides = element.querySelectorAll(".viewport > ul > li");
        var slide = slides[this.activeIndex];
        if (slide) {
          var radio = slide.querySelector(this.opts.radio);
          radio.checked = true;
          var event = new Event('change');
          radio.dispatchEvent(event);
        }
      }
    }.bind(this)

    this.resetTimer = function() {
      clearInterval(this.timer);
      if (opts.interval) {
        this.timer = setInterval(this.forward, parseInt(opts.interval));
      }
    }.bind(this)

    this.goto = function(event) {
      this.activeIndex = event.item.index;
      this.go();
    }.bind(this)

    this.go = function() {
      var index = this.activeIndex;
      if (!containers || !containers[0]) {
        return;
      }
      var firstSlide = containers[0].querySelector('li');
      if (!firstSlide) return;

      var amount = firstSlide.offsetWidth;

      var numSliders = containers.length;
      while (numSliders--) {
        containers[numSliders].style.left = index * -100 + '%';
      }

      this.moveNavs();

      this.performSelect();
    }.bind(this)

    this.moveNavs = function() {
      if (opts.nav) {
        var index = this.activeIndex,
            left = this.left,
            right = this.right;

        var navs = element.querySelectorAll(opts.nav);
        var startIndex = index * this.visibleSlides;
        var endIndex = startIndex + this.visibleSlides - 1;
        var total = this.slides.length;
        if (endIndex >= total) {
          endIndex = total - 1;
        }

        var startNav, endNav;
        if (startIndex === endIndex) {

          if (endIndex === total - 1) {

            startNav = navs[startIndex];
          } else {

            endNav = navs[endIndex];
          }
        } else {
          startNav = navs[startIndex];
          endNav = navs[endIndex];
        }

        startNav && startNav.insertBefore(left, startNav.firstChild);
        endNav && endNav.appendChild(right);

        if (index <= 0) {
          var parentNode = left.parentNode;
          parentNode && parentNode.removeChild(left);
        }
        if (index >= this.pages.length - 1) {
          var parentNode = right.parentNode;
          parentNode && parentNode.removeChild(right);
        }
      }
    }.bind(this)

    this.backward = function(_event) {
      this.paginate();

      if (this.activeIndex <= 0) {
        return;
      }

      if (this.activeIndex === 0) {
        this.activeIndex = this.pages.length + 1;
      }
      this.activeIndex -= 1;
      this.go();
      this.update();
      this.resetTimer();
    }.bind(this)

    this.forward = function(_event) {
      this.paginate();

      if (this.activeIndex >= this.pages.length - 1) {
        return;
      }

      if (this.activeIndex === this.pages.length) {
        this.activeIndex = -1;
      }
      this.activeIndex += 1;
      this.go();
      this.update();
      this.resetTimer();
    }.bind(this)

    this.paginate = function() {
      var container = containers && containers[0];
      this.slides.length = 0;
      var slides = [];
      if (container) {
        Array.prototype.push.apply(this.slides, Array.prototype.slice.call(container.children));
      }

      var firstSlide = container && container.querySelector('li')
        , visibleSlides = 0;

      if (firstSlide) {
        visibleSlides = this.visibleSlides = Math.round(viewport.offsetWidth / firstSlide.offsetWidth);
      }

      var images = element.querySelectorAll('.viewport > ul:first-of-type li img');
      var numPages = Math.ceil(this.slides.length / this.visibleSlides);
      var pages = this.pages;
      pages.length = 0;

      while (numPages--) {
        var pageIndex = pages.length;
        if(opts.thumbnail) {
          pages.push(images[pageIndex].src);
        } else {
          pages.push(pageIndex);
        }
      }

      if (this.activeIndex >= pages.length) {
        this.activeIndex = pages.length - 1;
      }
    }.bind(this)

    var touches = {
      "touchstart": {"x":-1, "y":-1},
      "touchmove" : {"x":-1, "y":-1},
      "touchend"  : false,
      "direction" : "undetermined"
    };

    this.touchHandler = function(event) {
      if (typeof event !== 'undefined'){
        if (typeof event.touches !== 'undefined') {
          var touch = event.touches[0], type = event.type;
          switch (type) {
            case 'touchstart':
            case 'touchmove':
              touches[type].x = touch.pageX;
              touches[type].y = touch.pageY;
              break;
            case 'touchend':
              touches[type] = true;
              var distance = Math.abs(touches.touchmove.x - touches.touchstart.x);

              if (touches.touchstart.x > -1 && touches.touchmove.x > -1 && distance > Number(opts.treshold || 50)) {
                touches.direction = touches.touchstart.x < touches.touchmove.x ? "right" : "left";

                event.preventDefault();

                this.trigger('swipe' + touches.direction, event);

                touches.touchmove.x = touches.touchstart.x = -1;
                touches.touchmove.y = touches.touchstart.y = -1;
              }
            default:
              break;
          }
        }
      }
    }.bind(this)

    this.on('mount', function() {
      viewport.addEventListener('touchstart', this.touchHandler, false);
      viewport.addEventListener('touchmove', this.touchHandler, false);
      viewport.addEventListener('touchend', this.touchHandler, false);
    });

    this.on('swipeleft', this.forward);
    this.on('swiperight', this.backward);

    var self = this;
    window.addEventListener('resize', function() {
      self.paginate();
      self.go();
      self.update();
    });

});
riot.tag2('datetime-input', '<label><span>{opts.date}</span><input value="{date.getDate()}/{date.getMonth()}/{date.getYear()}" type="{\'date\'}"></label><label><span>{opts.time}</span><select><option each="{this.times}" value="{value}">{text}</option></select></label><input type="hidden" name="{opts.name}">', 'datetime-input label,[riot-tag="datetime-input"] label,[data-is="datetime-input"] label{ display: inline-block; }', '', function(opts) {
    this.date = new Date(opts.value);
    this.times = [];

    var mintime = Number(opts.mintime || '1'),
        maxtime = Number(opts.maxtime || '24'),
        interval = Number(opts.interval || '1');

    for (mintime; mintime < maxtime; mintime += interval) {
      var hour = Math.floor(mintime * 60 / 60);
      var minute = mintime * 60 % 60;

      this.times.push({
        "text": hour + ':' + minute,
        "value": hour + ':' + minute
      });
    }

});
riot.tag2('calendar-event', '', '', '', function(opts) {
});


riot.tag2('full-calendar', '<input type="checkbox" name="calendar-view" id="calendar-view-switcher" checked="checked"><header class="calendar-filters"><h1 class="red">November 2015</h1><form><label class="blue" for="calendar-view-switcher">Switch to <span class="list-view">List</span><span class="calendar-view">Calendar</span> View</label><div class="styled-select"><select><option value="">Filter By Week</option></select></div><div class="styled-select"><select><option value="">Filter By Event Type</option><option value="Regula Event">Regular Event</option><option value="Private Event">Private Event</option><option value="Painting it Forward">Painting it Forward</option><option value="Little Brushes">Little Brushes</option></select></div></form></header><ol><li each="{eventDays}" class="{\'empty\': false}"><h2 class="weekday"><span class="short-day">{day}@firstDay.ToString("ddd")</span><span class="full-day">@firstDay.ToString("dddd MM/dd")</span></h2><div class="events"><h2 class="monthday">{day} @firstDay.Day</h2><calendar-event each="{events}"></calendar-event></div></li></ol><ajax-request if="{false}" method="GET" type="json" url="{url}"></ajax-request>', '', '', function(opts) {
    var self = this;
    var events;

    var days = opts.days;
    if (!days) {
      days = 'Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday,Sunday';
    }
    days = days.split(',');

    this.on('update', function() {
      if (opts.events !== events) {
        events = opts.events;
        console.log('fetch')
        this.fetchEvents();
      }
    });

    this.fetchEvents = function() {
      var today = new Date();
      var month = parseInt(opts.month || (today.getMonth() + ''));
      var year = parseInt(opts.year || (today.getYear() + ''));
      var events = opts.events;

      var start = this.start = new Date(year, month),
          end = this.end = new Date(year, month + 1, 0),
          startDay = start.getDay(),
          endDay = end.getDay();

      if (startDay > 0) {

        start.setDate(start.getDate() - startDay);
      }
      if (endDay < 6) {
        end.setDate(end.getDate() + (5 - endDay));
      }

      if (events.constructor !== Array) {
        var url = events;
        url += (url.indexOf('?') >= 0 ? '&' : '?');
        var params = [];
        params.push('start=' + encodeURIComponent(start.getTime() / 1000));
        params.push('end=' + encodeURIComponent(end.getTime() / 1000));

        url += params.join('&');
        this.url = url;
        this.update();
      }
    }.bind(this)

    function dateEquals(a, b) {
      return (
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate()
      );
    }

    this.render = function(results) {

      results.sort(function(a, b){
        return new Date(b.start) - new Date(a.start);
      });

      var start = this.start, end = this.end,
          thisDay = new Date(start.getTime()),
          days = this.eventDays;

      days.length = 0;

      var eventCounter = 0;

      while (thisDay <= end) {
        var eventDay = {
          'day': thisDay
        };
        var events = eventDay.events = [];

        var event = results[eventCounter];

        while (dateEquals(thisDay, new Date(event.start))) {
          events.push(event);
          eventCounter++;
          event = results[eventCounter];
        }

        thisDay = new Date(thisDay.getTime());
        thisDay.setDate(thisDay.getDate() + 1);
      }

      this.update();
    }.bind(this)

    this.arrangeEvents = function(events) {
      console.log(events)
    }.bind(this)

    this.on('mount', function() {
      var ajax = this.ajax = this.tags['ajax-request'];

      ajax.on('response', this.render);
    });
});
riot.tag2('geo-locator', '<yield></yield><ajax-request if="{false}" method="GET" type="json" url="{url}"></ajax-request>', '', '', function(opts) {
    this.longitude = null;
    this.latitude = null;
    this.loading = false;

    this.options = {
      'enableHighAccuracy': false,
      'timeout': Infinity,
      'maximumAge': 0
    }
    var GEOIPAPI = 'https://freegeoip.net/json/';

    var CACHEKEY = 'geolocation';
    var CACHEDURATION = 60 * 1000;

    var ajax = this.ajax = this.tags['ajax-request'];

    this.success = function(position) {
      var longitude = position.coords.longitude.toFixed(4);
      var latitude = position.coords.latitude.toFixed(4);
      var timestamp = position.timestamp;

      if (longitude === this.longitude && latitude === this.latitude) {
        return;
      }

      this.longitude = longitude;
      this.latitude = latitude;
      this.timestamp = timestamp;

      this.forward();
    }.bind(this)

    this.forward = function() {
      if (this.loading) {
        return;
      }

      if (opts.target) {
        this.loading = true;

        var longitude = this.longitude;
        var latitude = this.latitude;

        var storage;
        var cacheKey = CACHEKEY + '-' + longitude + '-' + latitude;

        if (opts.cache) {
          storage = window[opts.cache];
          var cache = storage.getItem(cacheKey);

          if (cache) {
            var data = JSON.parse(cache);
            var timestamp = data.timestamp;

            if (Date.now() - timestamp < CACHEDURATION) {
              this.loading = false;

              this.render(data, true);
              return;
            }
          }
        }

        var url = opts.target;
        url += (url.indexOf('?') >= 0 ? '&' : '?');

        var lonKey = opts.longitude || 'longitude';
        var latKey = opts.latitude || 'latitude';

        var params = [];

        params.push(lonKey + '=' + longitude);
        params.push(latKey + '=' + latitude);

        url += params.join('&');
        this.url = url;
        this.update();
      }
    }.bind(this)

    this.render = function(results, cached) {
      if (!cached && opts.cache) {
        var cacheKey = CACHEKEY + '-' + this.longitude + '-' + this.latitude;
        var storage = window[opts.cache];
        results.timestamp = Date.now();
        storage.setItem(cacheKey, JSON.stringify(results));
      }

      this.data = results;
      this.loading = false;
      this.update();
    }.bind(this)

    this.geoIP = function() {
      var self = this;
      if (this.loading) {
        return;
      }

      this.loading = true;

      var storage;

      if (opts.cache) {
        storage = window[opts.cache];
        var cache = storage.getItem(CACHEKEY);

        if (cache) {
          var data = JSON.parse(cache);

          var timestamp = self.timestamp = data.timestamp;
          self.longitude = data.longitude;
          self.latitude = data.latitude;

          if (Date.now() - timestamp < CACHEDURATION) {
            self.loading = false;
            self.forward();
            return;
          }
        }
      }

      var callbackName = 'geocoderCallback' + Math.round(100000 * Math.random());
      window[callbackName] = function(data) {
        delete window[callbackName];
        document.body.removeChild(script);
        self.longitude = data.longitude.toFixed(4);
        self.latitude = data.latitude.toFixed(4);
        self.timestamp = Date.now();

        if (storage) {
          data.timestamp = self.timestamp;
          storage.setItem(CACHEKEY, JSON.stringify(data));
        }

        self.loading = false;
        self.forward();
      };

      var url = opts.src || GEOIPAPI;
      url += (url.indexOf('?') >= 0 ? '&' : '?');

      var script = document.createElement('script');
      script.src = url + 'callback=' + callbackName;
      document.body.appendChild(script);
    }.bind(this)

    this.filter = function(data, path) {
      if (!path) return data;

      var levels = path.split('.');
      var level = levels.shift();
      var matches = level.match(/([\w\s]+)(?:\[?([\w\d\s]+)\]?)?/);
      if (matches) {
        var key = matches[1], subkey = matches[2];
        if (subkey) {
          data = data[key][subkey];
        } else {
          data = data[key];
        }
        return this.filter(data, levels.join('.'));
      }

      return data;
    }.bind(this)

    function cleanInt(x) {
      x = Number(x);
      return x >= 0 ? Math.floor(x) : Math.ceil(x);
    }

    this.normalizeOptions = function() {
      var options = this.options;
      options.enableHighAccuracy = opts['enable-high-accuracy'] || false;
      options.maximumAge = cleanInt(opts['maximum-age'] || '0');
      options.timeout = cleanInt(opts['timeout'] || 'Infinity');
    }.bind(this)

    this.on('mount', function() {

      ajax.on('response', this.render);

      if ("geolocation" in navigator) {

        var geolocation = navigator.geolocation;
        geolocation.getCurrentPosition(this.success, this.geoIP);

        var watchId = geolocation.watchPosition(this.success, this.geoIP);
      } else {

        this.geoIP();
      }
    });
});
riot.tag2('google-geocoder', '<input class="{⁗error⁗: error}" type="text" value="{this.query}" onchange="{changed}" onfocus="{focus}" onblur="{blur}"><button onclick="{geocode}">{opts.button}</button>', '', '', function(opts) {
    var BASE_URL = 'https://maps.googleapis.com/maps/api/geocode/json?address=';

    this.query = opts.placeholder;
    this.error = '';

    this.focus = function(e) {
      if (this.query === opts.placeholder) {
        this.query = '';
      }
    }.bind(this)

    this.blur = function(e) {
      if (this.query === '') {
        this.query = opts.placeholder;
      }
    }.bind(this)

    this.changed = function(e) {
      var query = e.target.value;
      var regex = new RegExp(opts.pattern);
      console.log(regex, query);
      if (regex.test(query)) {
        this.query = query;
      } else if (opts.onerror) {
        this.error = new Error('Please enter query in correct format');
        opts.onerror && opts.onerror(this.error);
      }
    }.bind(this)

    function parseResponse(response) {
      if (httpRequest.readyState === XMLHttpRequest.DONE) {
      if (httpRequest.status === 200) {
        alert(httpRequest.responseText);
      } else {
        alert('There was a problem with the request.');
      }
    }
      if (response && response.status === 'OK') {
        opts.onresults(response.results);
      }
    }

    this.geocode = function(e) {
      if (this.query === opts.placeholder) {
        this.error = new Error('Query is required');
        opts.onerror && opts.onerror(this.error);
        return;
      }

      var httpRequest = new XMLHttpRequest();
      httpRequest.onreadystatechange = function() {
        if (httpRequest.readyState === XMLHttpRequest.DONE) {
          if (httpRequest.status === 200) {
            var json = JSON.parse(httpRequest.responseText);
            if (json.status === 'OK') {
              opts.onresults && opts.onresults(json.results);
            } else {
              var error = new Error('Geocoding failed with status: ' + responseText.status);
              opts.onerror && opts.onerror(error);
            }
          } else {
            var error = new Error('Request failed with status: ' + httpRequest.status);
            opts.onerror && opts.onerror(error);
          }
        }
      };

      var url = BASE_URL + this.query;
      if (opts.components) {
        url += '&components=' + opts.components;
      }

      httpRequest.open('GET', url, true);
      httpRequest.send(null);
    }.bind(this)
});
function camelCaseMixin() {
  this.camelCase = function(dashedText) {
    return dashedText.replace(/-([a-z])/g, function(txt){
      return txt[1].toUpperCase();
    });
  }
}

riot.tag2('google-map', '<yield></yield>', 'google-map,[riot-tag="google-map"],[data-is="google-map"]{ display: block; } google-map > div,[riot-tag="google-map"] > div,[data-is="google-map"] > div{ width: 320px; height: 240px; }', '', function(opts) {
    var tag = this, GM = google.maps;
    var zoom = opts.zoom || 3;
    var minZoom = opts['min-zoom'];
    var maxZoom = opts['max-zoom'];
    var center = (opts.center || '58.33,-98.52').split(',');
    var width = (opts.width || tag.root.offsetWidth || 320) + 'px';
    var height = (opts.height || tag.root.offsetHeight || 240) + 'px';
    var container = this.root;
    var markers = opts.markers || [];

    var mapOptions = {
      center: new google.maps.LatLng(center[0], center[1]),
      zoom: parseInt(zoom),
      minZoom: (minZoom && parseInt(minZoom)) || null,
      maxZoom: (maxZoom && parseInt(maxZoom)) || null,
      scaleControl: opts.scale,
      scrollwheel: opts.scrollwheel !== "false",

      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: opts.styles
    };

    if (opts.static) {
      mapOptions.disableDoubleClickZoom = true;
      mapOptions.draggable = false;
      mapOptions.mapTypeControl = false;
      mapOptions.panControl = false;
      mapOptions.rotateControl = false;
      mapOptions.scaleControl = false;
      mapOptions.scrollwheel = false;
      mapOptions.streetViewControl = false;
      mapOptions.zoomControl = false;
    }

    if ((minZoom || maxZoom) && (minZoom === maxZoom)) {
      mapOptions.disableDoubleClickZoom = true;
      mapOptions.scaleControl = false;
      mapOptions.zoomControl = false;
    }

    function initialize() {
      var map = tag.map = new GM.Map(container, mapOptions);

      if (opts['load-geojson']) {
        map.data.loadGeoJson(opts['load-geojson']);
      }

      var geoJsonData = opts['add-geojson'];
      if (geoJsonData && geoJsonData.features.length > 0) {
        map.data.addGeoJson(geoJsonData);
        this.geojson = geoJsonData;
      }

      tag.update();

      if (opts.bounds) {
        var latLngs = opts.bounds.split(',');
        var bounds = new google.maps.LatLngBounds();
        for (var i=0, count=latLngs.length; i<count; i+=2) {
          var latLng = new google.maps.LatLng(latLngs[i+1], latLngs[i]);
          bounds.extend(latLng);
        }

        map.fitBounds(bounds);
      }

      if (opts.static) return;

      GM.event.addListener(map.data, 'mouseover', function(dataMouseEvent) {
        var feature = dataMouseEvent.feature;
        opts.onmouseover && opts.onmouseover.call(tag, dataMouseEvent);
      });

      GM.event.addListener(map.data, 'mouseout', function(dataMouseEvent) {
        var feature = dataMouseEvent.feature;
        opts.onmouseout && opts.onmouseout.call(tag, dataMouseEvent);
      });

      GM.event.addListener(map, 'idle', function() {
        tag.update();
        if (opts.debug) {
          console.log('Idle at:', map.getCenter().toString());
        }
      });
    }

    this.on('mount', function() {
      initialize();
    });

    this.on('update', function() {
      var json = opts['add-geojson']
      if (this.map && json && json.features.length > 0 && json !== this.geojson) {
        this.map.data.addGeoJson(json);
        this.geojson = json;
      }

      if (this.map) {

        this.map.data.setStyle(opts['set-style']);
      }
    });
});

riot.tag2('fusion-layer', '', '', '', function(opts) {
    var script = document.createElement('script');
    var url = ['https://www.googleapis.com/fusiontables/v1/query?'];
    url.push('sql=');
    var query = 'SELECT ' + opts.select + ' FROM ' + opts.from;
    if (opts.where) {
      query += ' WHERE ' + opts.where;
    }
    var encodedQuery = encodeURIComponent(query);
    url.push(encodedQuery);
    url.push('&callback=drawMap');

    script.src = url.join('');

    this.on('update', function() {
      if (!opts.map) return;
      if (this.layer) return;
      var tag = this, layerOpts = {
        map: opts.map,
        heatmap: { enabled: opts.heatmap || false },
        query: {
          select: opts.select,
          from: opts.from,
          where: opts.where
        },
        styles: opts.styles,
        options: {
          styleId: opts['style-id'],
          templateId: opts['template-id']
        }
      };

      this.layer = new google.maps.FusionTablesLayer(layerOpts);
    });
});

riot.tag2('kml-layer', '', '', '', function(opts) {
    this.mixin(new camelCaseMixin());

    this.on('update', function() {
      if (!opts.map) return;
      if (this.layer) return;
      var tag = this, layerOpts = {};

      for (var prop in opts) {
        if (opts.hasOwnProperty(prop)) {
          var item = opts[prop];
          layerOpts[this.camelCase(prop)] = item;
        }
      }

      this.layer = new google.maps.KmlLayer(layerOpts);
      google.maps.event.addListener(this.layer, 'click', function(kmlEvent) {
        tag.trigger('click', kmlEvent);
      });
    });
});

riot.tag2('custom-overlay', '<yield></yield>', 'custom-overlay,[riot-tag="custom-overlay"],[data-is="custom-overlay"]{ display: block; position: absolute; }', '', function(opts) {
    var container = this.root, previousPosition;
    CustomOverlay.prototype = new google.maps.OverlayView();

    function CustomOverlay(options) {
      if (options.map) {
        this.setMap(options.map);
      }
      this.position = null;
    }

    CustomOverlay.prototype.onAdd = function() {
      var panes = this.getPanes();
      panes[opts.pane || 'overlayMouseTarget'].appendChild(container);
    }

    CustomOverlay.prototype.draw = function() {
      var position = opts.position;
      if (position === this.position) {
        return;
      }

      if (!position) {
        container.style.left = '-99999px';
        container.style.top = '-99999px';
        this.position = null;
        return;
      }

      var overlayProjection = this.getProjection();
      if (!overlayProjection) return;

      var latlng;
      if (typeof position === 'string') {
        position = position.split(',');
        latlng = new google.maps.LatLng(position[1], position[0]);
      } else if (position[1]) {

        latlng = new google.maps.LatLng(position[1], position[0]);
      } else if (position.lat) {
        latlng = position;
      }
      var point = overlayProjection.fromLatLngToDivPixel(latlng);
      container.style.left = point.x + 'px';
      container.style.top = point.y + 'px';

      if (opts.zoom) {
        opts.map.panTo(latlng);
        opts.map.setZoom(parseInt(opts.zoom));
      }

      this.position = opts.position;
    }

    CustomOverlay.prototype.onRemove = function() {

    }

    this.attachedToMap = false;
    var marker = new CustomOverlay({
      map: opts.map
    });

    this.on('update', function() {
      if (!opts.map) return;
      marker.setMap(opts.map);
      marker.draw();
      this.attachedToMap = true;
    });

});

riot.tag2('info-window', '<yield></yield>', '', '', function(opts) {
    this.mixin(new camelCaseMixin());

    var opts = this.opts, options = {},
        notInfoWindowsOpts = ['map', 'position', 'name', 'info'];
    for (var prop in opts) {
      if (opts.hasOwnProperty(prop)) {
        if (notInfoWindowsOpts.indexOf(prop) > -1) continue;
        var item = opts[prop];
        options[this.camelCase(prop)] = item;
      }
    }

    var infowindow = this.infowindow = new google.maps.InfoWindow(options);

    var marker = this.marker = new google.maps.Marker({
      clickable: false,
      visible: false
    });

    this.on('update', function() {
      if (!opts.map) return;
      var position = opts.position;
      if (!position) {
        infowindow.close();
        return;
      }

      if (position[1]) {
        position = {lng: position[0], lat: position[1]};
      }
      marker.setPosition(position);
      marker.setMap(opts.map);

      infowindow.setContent(this.root.innerHTML);
      infowindow.open(opts.map, marker);
    });
});

riot.tag2('label-input-set', '<label onclick="{selectInput}" __hidden="{!(!value || value == ⁗⁗)          id=⁗{opts.name}⁗}">{opts.title || opts.label}<yield></yield></label><input type="{type}" id="{opts.name}" name="{opts.name}" value="{value}" tabindex="{opts.index}" __autofocus="{opts.autofocus}" __disabled="{opts.disabled}" __checked="{opts.checked}" __required="{opts.required}" __autofocus="{opts.autofocus}" placeholder="{opts.placeholder}" minlength="{opts.minlength}" maxlength="{opts.maxlength}" rangelength="{opts.rangelength}" min="{opts.min}" max="{opts.max}" range="{opts.range}" step="{opts.step}" pattern="{opts.pattern}" oninput="{input}" oninvalid="{oninvalid}" aria-required="{opts.required}" aria-invalid="{invalid}"><input if="{opts.type == ⁗checkbox⁗}" type="hidden" name="{opts.type == ⁗checkbox⁗? opts.name : null}" value="false"><span if="{opts.type == ⁗checkbox⁗}" onclick="{selectInput}"></span>', 'label-input-set,[riot-tag="label-input-set"],[data-is="label-input-set"]{ display: inline-block; position: relative; box-sizing: border-box !important; } label-input-set > *,[riot-tag="label-input-set"] > *,[data-is="label-input-set"] > *{ display: inline-block; vertical-align: middle; } label-input-set[position="relative"] > *,[riot-tag="label-input-set"][position="relative"] > *,[data-is="label-input-set"][position="relative"] > *{ position: relative; } label-input-set label,[riot-tag="label-input-set"] label,[data-is="label-input-set"] label{ position: absolute; top: 0; bottom: 0; left: 1em; display: inline-block; } label-input-set label:before,[riot-tag="label-input-set"] label:before,[data-is="label-input-set"] label:before{ content: \'\'; display: inline-block; height: 100%; vertical-align: middle; } label-input-set input[type="date"],[riot-tag="label-input-set"] input[type="date"],[data-is="label-input-set"] input[type="date"]{ padding-left: 6.5em; -webkit-appearance: textfield; -moz-appearance: textfield; min-height: 1.2em; } label-input-set.half input[type="date"],[riot-tag="label-input-set"].half input[type="date"],[data-is="label-input-set"].half input[type="date"]{ padding-left: 5em; padding-top: 0.35em; padding-bottom: 0.35em; } label-input-set input[type="date"].input,[riot-tag="label-input-set"] input[type="date"].input,[data-is="label-input-set"] input[type="date"].input{ padding-left: 8px; } label-input-set[type="checkbox"],[riot-tag="label-input-set"][type="checkbox"],[data-is="label-input-set"][type="checkbox"]{ direction: rtl; text-align: left; } label-input-set[type="checkbox"] > *,[riot-tag="label-input-set"][type="checkbox"] > *,[data-is="label-input-set"][type="checkbox"] > *{ vertical-align: top; } label-input-set input[type="checkbox"],[riot-tag="label-input-set"] input[type="checkbox"],[data-is="label-input-set"] input[type="checkbox"]{ position: absolute; opacity: 0; width: 1.56em; height: 1.56em; margin: 0; } label-input-set[type="checkbox"] > label,[riot-tag="label-input-set"][type="checkbox"] > label,[data-is="label-input-set"][type="checkbox"] > label{ direction: ltr; } label-input-set[type="checkbox"] > span,[riot-tag="label-input-set"][type="checkbox"] > span,[data-is="label-input-set"][type="checkbox"] > span{ border: 1px solid #003366; background-color: white; width: 1.56em; height: 1.56em; line-height: 1; text-align: center; } label-input-set[type="checkbox"] > span:before,[riot-tag="label-input-set"][type="checkbox"] > span:before,[data-is="label-input-set"][type="checkbox"] > span:before{ font-size: 1.25em; display: inline-block; vertical-align: middle; } label-input-set input[type="checkbox"]:checked ~ span:before,[riot-tag="label-input-set"] input[type="checkbox"]:checked ~ span:before,[data-is="label-input-set"] input[type="checkbox"]:checked ~ span:before{ content: "X"; } label-input-set input[type="checkbox"]:focus ~ span,[riot-tag="label-input-set"] input[type="checkbox"]:focus ~ span,[data-is="label-input-set"] input[type="checkbox"]:focus ~ span{ outline: 1px dotted #212121; outline: -webkit-focus-ring-color auto 5px; }', '', function(opts) {
    this.invalid = (opts.required && !opts.value);
    var name = this.name = opts.name;
    this.type = opts.type || 'text';
    switch (this.type) {
      case 'date':
      case 'time':
      case 'text':
        this.type = 'text';
        break;
    }

    var input;

    var self = this;
    self.value = '';

    this.input = function(e) {
      this.value = e.target.value;
    }.bind(this)

    this.selectInput = function(e) {
      if (!e.target.href) {
        input.focus();
        input.click();
      }

      return true;
    }.bind(this)

    this.oninvalid = function(event) {
      if (opts.errormessage) {
        input.setCustomValidity && input.setCustomValidity(opts.errormessage);
      }
      return true;
    }.bind(this)

    this.on('mount', function() {
      var inputs = this[name];
      input = (opts.type === 'checkbox'? inputs[0] : inputs);
      if (opts.value) {

        this.value = input.value = opts.value;
        this.update();
      }
    });

});
riot.tag2('light-box', '<div class="content-wrapper"><div if="{this.type == \'html\'}"></div><img if="{this.type == \'image\'}" riot-src="{this.target}"><iframe if="{this.type == \'iframe\'}" riot-src="{this.target}"></iframe></div>', 'light-box,[riot-tag="light-box"],[data-is="light-box"]{ position: fixed; top: 0; right: 0; bottom: 0; left: 0; z-index: 99999; overflow-y: auto; visibility: hidden; opacity: 0; } light-box > div:after,[riot-tag="light-box"] > div:after,[data-is="light-box"] > div:after{ content: \'×\'; position: absolute; top: -1em; right: -1em; padding: 0.5em; border-radius: 100%; cursor: pointer; text-align: center; }', '', function(opts) {
    var self = this, el = this.root;
    this.target = null;
    var target = self.opts.target;
    var triggers = document.querySelectorAll(target);
    var wrapper;

    function open(e) {
      e.preventDefault();
      var target = this.getAttribute('href');

      if (!target) {
        return true;
      }

      self.target = target;

      if (target.indexOf('#') === 0) {
        self.type = "html";
        self.update();
        var content = document.querySelector(target);
        wrapper.querySelector('div').innerHTML = content.outerHTML;

      } else if (/^https?:\/\/.+\.(gif|png|jpg|jpeg)$/i.test(target)) {
        self.type = 'image';
      } else {
        self.type = 'iframe';
      }

      if(self.opts.isform) {
        riot.mount("label-input-set");
        $("form").each(function(){
          $(this).validate();
        })
      }

      self.update();
      el.style.visibility = 'visible';
      el.style.opacity = 1;
    }

    for(var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', open, false);
    }

    this.close = function(event) {

      var target = event.target;
      if (target === el || target === wrapper) {
        el.style.visibility = 'hidden';
        el.style.opacity = 0;
      }
    }.bind(this)

    this.on('mount', function() {

      wrapper = el.querySelector('div');
    });

    el.addEventListener('click', this.close);
});
riot.tag2('light-box-old', '<yield></yield>', 'light-box-old #lightbox-content,[riot-tag="light-box-old"] #lightbox-content,[data-is="light-box-old"] #lightbox-content{ display: none; }', 'onclick="{launchLightbox}"', function(opts) {
    this.startInput = false;
    var self = this;

    this.launchLightbox = function(e) {
      var lightbox = document.getElementById(opts.target);
      var lightboxMask = document.getElementById("lightbox-mask");
      var lightboxContent = document.getElementById("lightbox-content");
      if(opts.class) {
        lightbox.setAttribute("class", opts.class);
      }
      lightbox.appendChild(lightboxContent);
      lightboxMask.style.display = 'block';
    }.bind(this)

});

riot.tag2('light-box', '<div class="content-wrapper {this.type}-content"><div if="{this.type == \'html\'}"></div><img if="{this.type == \'image\'}" riot-src="{this.target}"><iframe if="{this.type == \'iframe\'}" riot-src="{this.target}"></iframe></div>', 'light-box,[riot-tag="light-box"],[data-is="light-box"]{ position: fixed; top: 0; right: 0; bottom: 0; left: 0; z-index: 99999; overflow-x: hidden; overflow-y: auto; visibility: hidden; opacity: 0; } light-box > div:after,[riot-tag="light-box"] > div:after,[data-is="light-box"] > div:after{ content: \'\\00D7\'; position: relative; display: inline-block; vertical-align: top; padding: 0.5em; border-radius: 100%; cursor: pointer; text-align: center; -webkit-transform: translate(-50%, -50%); -moz-transform: translate(-50%, -50%); -ms-transform: translate(-50%, -50%); -o-transform: translate(-50%, -50%); transform: translate(-50%, -50%); }', '', function(opts) {
    var self = this, el = this.root;
    this.target = null;
    var target = self.opts.target;
    var triggers = document.querySelectorAll(target);
    var wrapper, body = document.querySelector('body');

    function open(e) {
      e.preventDefault();
      var target = this.getAttribute('href'),
          placement = this.getAttribute('target');

      self.reset();

      if (!target) {
        return true;
      }

      self.target = target;

      if (target.indexOf('#') === 0) {
        self.type = "html";
        self.update();
        var content = self.content = document.querySelector(target);
        var clone = self.clone = content.cloneNode(true);

        content.parentNode.replaceChild(clone, content);

        var container = wrapper.querySelector('div');
        container.innerHTML = '';

        container.appendChild(content);

      } else if (/.+\.(gif|png|jpg|jpeg)(?:\?([\w-]+(=[\w-]*)?(&[\w-]+(=[\w-]*)?)*)?)?$/i.test(target)) {
        self.type = 'image';
      } else {
        self.type = 'iframe';
      }

      self.update();
      el.style.visibility = 'visible';
      el.style.opacity = 1;
      body.style.overflow = 'hidden';

    }

    for(var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', open, false);
    }

    this.close = function(event) {

      var target = event.target;
      if (target === el || target === wrapper) {
        el.style.visibility = 'hidden';
        el.style.opacity = 0;

        this.type = null;
        this.target = null;
        this.update();
        this.reset();
      }
    }.bind(this)

    this.reset = function() {
      var clone = this.clone;
      if (clone) {

        clone.parentNode.replaceChild(this.content, clone);
        this.clone = null;
      }
      body.style.overflow = '';
    }.bind(this)

    this.on('mount', function() {

      wrapper = el.querySelector('div');
    });

    el.addEventListener('click', this.close);
});
riot.tag2('pinots-painter-loader', '<div each="{painter, idx in painters}" class="field-group"><h4>Guest {(idx + 1)} (optional)</h4><fieldset class="half first-half inline-block"><label>Guest {(idx + 1)} Name</label><input type="text" name="Data[{parent.opts.index}].PainterData[{idx}].Name" value="{painter.Name}" placeholder="Guest Name"></fieldset><fieldset class="half second-half inline-block"><label>Guest Email</label><input type="text" name="Data[{parent.opts.index}].PainterData[{idx}].Email" value="{painter.Email}" placeholder="Guest Email"></fieldset></div><ajax-request if="{false}" method="POST" type="json" url="{opts.url}" params="Seats={opts.seats}&OrderDetailId={opts.orderDetailId}"></ajax-request>', '', '', function(opts) {
  var ajax = this.ajax = this.tags['ajax-request'];
  this.painters = [];

  this.render = function(results) {
    if (results.Success) {
      var painters = this.painters,
          seats = Number(opts.seats);

      painters.length = 0;
      Array.prototype.push.apply(painters, results.Painters);
      var count = painters.length;
      while (count++ < seats) {
        painters.push({});
      };

      this.update();
      this.root.onload && this.root.onload(results);
    }
  }.bind(this)

  this.on('mount', function() {
    ajax.on('response', this.render);
  });
});
riot.tag2('raw-html', '', '', '', function(opts) {
  this.on('update', function() {
    this.root.innerHTML = opts.content
  });
});
riot.tag2('sticky-heading', '<div class="original {sticked: sticked}"><yield></yield></div><div class="cloned {sticked: sticked}"><yield></yield></div>', 'sticky-heading .cloned,[riot-tag="sticky-heading"] .cloned,[data-is="sticky-heading"] .cloned{ position: fixed; top: 0; left: 0; width: 100%; z-index: 500; color: inherit; background-color: inherit; } sticky-heading .original.sticked,[riot-tag="sticky-heading"] .original.sticked,[data-is="sticky-heading"] .original.sticked{ visibility: hidden; } sticky-heading .cloned.sticked,[riot-tag="sticky-heading"] .cloned.sticked,[data-is="sticky-heading"] .cloned.sticked{ display: initial; }', '', function(opts) {
    var tag = this;
    var element = tag.root;
    tag.sticked = false;

    var fromSelector = opts.from || 'body';

    this.on('mount', function() {
      var from = document.querySelector(fromSelector),
          documentElement = document.documentElement,
          original = element.querySelector('.original'),
          rect = original.getBoundingClientRect()
          cloned = element.querySelector('.cloned');

      var scrollIntervalID = setInterval(stickIt, 10);

      function stickIt() {

        var rect = element.getBoundingClientRect();
        var top = rect.top + window.pageYOffset - documentElement.clientTop;

        var scrollLeft = (window.pageXOffset !== undefined) ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
        var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

        var sticked = scrollTop >= top + 1;
        if (sticked != tag.sticked) {

          tag.sticked = sticked;
          tag.update();
        }
      }
    });

});
riot.tag2('studio-info', '<div class="location-name"><h2 class="blue"><strong class="desktop-only">{opts.studio.Name}</strong><strong class="mobile-only"><a href="/{opts.studio.URLExtension}">{opts.studio.Name}<span class="red icon-right-open-big"></span></a></strong></h2><p class="distance subhead">{opts.studio.Miles}</p></div><div class="container"><div class="studio-contact-buttons"><h4 class="blue"><ul class="amenities"><li if="{opts.studio.IsBYOB}"><strong>BYOB</strong></li><li if="{opts.studio.IsMobile}" class="icon-mobile-party"></li></ul></h4><p class="button desktop-only"><a href="/{opts.studio.URLExtension}">Visit Studio Page</a></p><p class="desktop-only direction-link"><a href="{opts.studio.DisplayGoogleMapURL}" class="icon-location">Get Directions</a></p><p class="desktop-only"><a href="/Locations/{opts.studio.URLExtension}" class="icon-location">Map this location</a></p><a class="mobile-only icon-email circled blue button" href="mailto:{opts.studio.Email}"></a><a class="mobile-only icon-phone circled blue button" href="tel:{opts.studio.PrimaryPhone}"></a><a class="mobile-only icon-location circled blue button" href="{opts.studio.DisplayGoogleMapURL}"></a></div><div class="studio-info"><div><h4 class="blue"><ul class="amenities"><li if="{opts.studio.IsBYOB}"><strong>BYOB</strong></li><li if="{opts.studio.IsMobile}" class="icon-mobile-party"></li></ul></h4><a href="/{opts.studio.URLExtension}" class="studio-link button desktop-only">Visit Studio Page</a></div><div><p> {opts.studio.Address}<br> {opts.studio.City? opts.studio.City + \', \' : \'\'}{opts.studio.State} {opts.studio.ZIP} <br></p><p class="desktop-only direction-link"><a href="{opts.studio.DisplayGoogleMapURL}" class="icon-location">Get Directions</a></p><p class="desktop-only map-link"><a href="/Locations/{opts.studio.URLExtension}" class="icon-location">Map this location</a></p></div><div class="desktop-only contact-info"><p><a class="studio-link" href="/{opts.studio.URLExtension}">http://www.pinotspalette.com/{opts.studio.URLExtension}</a><br><a href="mailto:{opts.studio.Email}">{opts.studio.Email}</a><br> {opts.studio.PrimaryPhone} </p></div></div></div>', 'studio-info,[riot-tag="studio-info"],[data-is="studio-info"]{ display: block; } studio-info > div,[riot-tag="studio-info"] > div,[data-is="studio-info"] > div{ }', '', function(opts) {
});

riot.tag2('studio-finder', '<form if="{!opts.form}" onsubmit="{search}"><div if="{!nearest}" class="float-right"><label for="studio-finder-state-selector">Filter by State</label><select id="studio-finder-state-selector" name="state" onchange="{filterByState}"><option value="" 4>Filter by State</option><option each="{state in this.states}" value="{state}" 7>{state}</option></select></div><div if="{nearest}" class="float-right"><a href="#" onclick="{clearQuery}">Or, view a list of all available locations ></a></div><div class="fill-width"><label class="float-left" for="studio-finder-query">Find a Studio</label><button class="float-right">Go</button><div class="fill-width"><input id="studio-finder-query" type="text" placeholder="Search by City + State or Zip Code" name="query" value="{query}" onchange="{updateQuery}"></div></div></form><figure class="static-map" riot-tag="google-map" if="{nearest}" zoom="11" center="{parent.nearest.Latitude},{parent.nearest.Longitude}" scrollwheel="false"><img width="100%" riot-src="http://maps.googleapis.com/maps/api/staticmap?size=600x265&amp;scale=2&amp;maptype=roadmap&amp;format=jpg&amp;visual_refresh=true&amp;center={parent.nearest.Address}, {parent.nearest.City}, {parent.nearest.State} {parent.nearest.ZIP}&amp;zoom=11&amp;markers=size:mid%7Ccolor:0xff0000%7Clabel:1%7C({parent.nearest.Address}, {parent.nearest.City}, {parent.nearest.State} {parent.nearest.ZIP})" alt="Google Map of {parent.nearest.Address}, {parent.nearest.City}, {parent.nearest.State} {parent.nearest.ZIP}"><figcaption class="info-window" riot-tag="custom-overlay" map="{map}" position="{parent.nearest? parent.nearest.Longitude + \',\' +  parent.nearest.Latitude : \'\'}" zoom="11" studio="{parent.nearest}"><span class="icon-circle-empty icon-marker"></span><div><p class="title"><a href="/{opts.studio.URLExtension}">{opts.studio.City}, {opts.studio.State} - {opts.studio.Name}</a></p><p class="address"> {opts.studio.Address}, {opts.studio.City}, {opts.studio.State} {opts.studio.ZIP}<br> Email: <a href="mailto:{opts.studio.Email}">{opts.studio.Email}</a><br> Tel: {opts.studio.PrimaryPhone} </p><a class="button" href="/{opts.studio.URLExtension}">Visit Studio Page</a></div></figcaption></figure><div if="{nearest}" class="nearest-studio"><div><studio-info studio="{nearest}"></studio-info></div></div><div each="{key in this.sections}"><h1 class="sticky centered red state-name" data-offset="header.yellow.widget">{STATES[key]}</h1><div><studio-info each="{studio in studios[key]}" studio="{studio}"></studio-info></div></div><ajax-request if="{false}" method="GET" type="json" url="{url}"></ajax-request>', 'studio-finder form > div,[riot-tag="studio-finder"] form > div,[data-is="studio-finder"] form > div{ padding: 1em; } studio-finder form input,[riot-tag="studio-finder"] form input,[data-is="studio-finder"] form input{ width: 100%; } studio-finder form label,[riot-tag="studio-finder"] form label,[data-is="studio-finder"] form label{ margin-right: 1em; }', '', function(opts) {
    var STATES = this.STATES = {"AL":"Alabama","AK":"Alaska","AS":"American Samoa","AZ":"Arizona","AR":"Arkansas","CA":"California","CO":"Colorado","CT":"Connecticut","DE":"Delaware","DC":"District Of Columbia","FM":"Federated States Of Micronesia","FL":"Florida","GA":"Georgia","GU":"Guam","HI":"Hawaii","ID":"Idaho","IL":"Illinois","IN":"Indiana","IA":"Iowa","KS":"Kansas","KY":"Kentucky","LA":"Louisiana","ME":"Maine","MH":"Marshall Islands","MD":"Maryland","MA":"Massachusetts","MI":"Michigan","MN":"Minnesota","MS":"Mississippi","MO":"Missouri","MT":"Montana","NE":"Nebraska","NV":"Nevada","NH":"New Hampshire","NJ":"New Jersey","NM":"New Mexico","NY":"New York","NC":"North Carolina","ND":"North Dakota","MP":"Northern Mariana Islands","OH":"Ohio","OK":"Oklahoma","OR":"Oregon","PW":"Palau","PA":"Pennsylvania","PR":"Puerto Rico","RI":"Rhode Island","SC":"South Carolina","SD":"South Dakota","TN":"Tennessee","TX":"Texas","UT":"Utah","VT":"Vermont","VI":"Virgin Islands","VA":"Virginia","WA":"Washington","WV":"West Virginia","WI":"Wisconsin","WY":"Wyoming", "Canada": "Canada"};

    var NEARBYKEY = 'NearbyLocations';
    STATES[NEARBYKEY] = 'Other Nearby Locations';

    var self = this;
    var studios = this.studios = [];
    var studiosByState = this.studiosByState = {};
    var states = this.states = [];

    this.sections = [];

    this.nearest = null;
    var nearests = studios[NEARBYKEY] = [];

    this.query = "";
    this.filter = "";

    this.search = function(event) {
      event && event.preventDefault();

      var query = this.query;
      nearests.length = 0;
      self.nearest = null;

      this.updateForms();

      window.location.hash = '#' + query;

      if (!query) {

        this.sections = this.states;
        this.update();
        return;
      }

      studios.forEach(function(studio) {
        var city = studio.City || '',
            state = studio.State || '',
            zip = studio.ZIP || '';

        var haystack1 = city + ', ' + state + ' ' + zip
        var haystack2 = city + ', ' + (STATES[state] || '') + ' ' + zip;

        if (haystack1.indexOf(query) > -1 || haystack2.indexOf(query) > -1) {
          if (!self.nearest) {
            self.nearest = studio;
          } else {
            nearests.push(studio);
          }
        }
      });

      this.sections = [NEARBYKEY];

      this.update();

      return false;
    }.bind(this)

    this.updateQuery = function(event) {
      var input = event.target;
      this.query = input.value;

      if (input.type === 'select-one') {
        this.search(event);
      }
    }.bind(this)

    this.clearQuery = function() {
      this.query = "";
      this.search();
    }.bind(this)

    this.filterByState = function(e) {
      this.filter = e.target.value;
    }.bind(this)

    this.reset = function(results) {

      studios.length = 0;
      states.length = 0;
      studiosByState = this.studiosByState = {};

      nearests = studios['NearbyLocations'] = nearests;

      Array.prototype.push.apply(studios, results.Locations);

      studios.forEach(function(studio) {
        var state = studio.State;

        if (!state) {
          state = 'Canada';
        }
        if (!studios[state]) {
          studios[state] = [];
          states.push(state);
        }

        studios[state].push(studio);
      });

      states.sort();

      this.sections = states;

      window.location.hash = '#!';

      if (this.query) {
        this.search();
      }

      this.update();
    }.bind(this)

    this.on('mount', function() {
      var ajax = this.ajax = this.tags['ajax-request'];
      ajax.on('response', this.reset);
    });

    this.on('update', function() {
      var src = opts.src;
      if (src !== this.url) {

        this.url = src;
      }
    });

    if (opts.form) {
      var forms = document.querySelectorAll(opts.form),
          count = forms.length;
      while (count--) {
        var form = forms[count];
        form.addEventListener('input', this.updateQuery);
        form.addEventListener('change', this.updateQuery);
        form.addEventListener('submit', this.search);
      }
    }

    this.updateForms = function() {
      if (opts.form) {
        var forms = document.querySelectorAll(opts.form),
            count = forms.length;
        while (count--) {
          var form = forms[count];
          form.setAttribute('data-query', this.query);

          var elements = form.elements;
          for (i=0; i<elements.length; i++){
            var element = elements[i];
            if (element.value !== this.query) {
              element.value = this.query;
            }
          }
        }
      }
    }.bind(this)

    var self = this;
    riot.route(function(query) {
      if (query === '!') {
        query = '';
      }
      self.query = query;
      self.search();
    });
    riot.route.start(true);

    var q = riot.route.query();
    if (q.query) {
      this.query = q.query;
      this.search();
    }
});
riot.tag2('svg-image', '', 'svg-image,[riot-tag="svg-image"],[data-is="svg-image"]{ display: inline-block; }', '', function(opts) {
    this.onLoad = function() {
      var xhr = this.request;
      if (xhr.readyState === xhr.DONE) {
        if (xhr.status === 200) {
          this.root.innerHTML = xhr.responseText;
          if (opts.width) {
            this.root.style.width = opts.width + 'px';
          }
          this.update();
        }
      }
    }.bind(this)
    this.request = null;
    var previousSrc = '';
    this.on('update', function() {
      var src = opts.src;
      if (src !== previousSrc) {
        var xhr = this.request = new XMLHttpRequest();
        xhr.addEventListener('load', this.onLoad);
        xhr.open('GET', src);
        xhr.overrideMimeType('text/xml');
        xhr.send();
        previousSrc = src;
      }
    });
});
//# sourceMappingURL=tags.js.map

riot.mixin('Selectors', {
  init: function() {
    var $ = {};

    function isElementInViewport (el) {
      var rect = el.getBoundingClientRect();

      return rect.bottom > 0 &&
        rect.right > 0 &&
        rect.left < (window.innerWidth || document. documentElement.clientWidth) /*or $(window).width() */ &&
        rect.top < (window.innerHeight || document. documentElement.clientHeight) /*or $(window).height() */;
    }
    
    $.closest = function(el, fn) {
      return el && (fn(el) ? el : $.closest(el.parentNode, fn));
    }

    $.visible = function(el) {
      return isElementInViewport(el);
    }

    $.on = function(el, eventType, handler) {
      var eventTypes = eventType.split(/[\s,]+/), count = eventTypes.length;
      while (count--) {
        (function(type, handler) {
          if (el.addEventListener) {
            el.addEventListener(type, handler, false);
          } else if (el.attachEvent) {
            el.attachEvent('on'+type, handler); 
          }
        })(eventTypes[count], handler);
      }
    }

    $.once = function(el, eventType, handler) {
      var args = Array.prototype.slice.call(arguments);
      var onceHandler = function() {
        var result = handler.apply(handler, args);
        $.off(el, eventType, onceHandler);
        return result;
      }
      $.on(el, eventType, onceHandler);
    }

    $.off = function(el, eventType, handler) {
      var eventTypes = eventType.split(/[\s]+/), count = eventTypes.length;
      while (count--) {
        (function(type, handler) {
          if (el.removeEventListener) {
            el.removeEventListener(type, handler, false);
          } else if (el.detachEvent) {
            el.detachEvent('on'+type, handler); 
          }
        })(eventTypes[count], handler)
      }
    }
    
    this.$ = $;
  }
});